import React, { useEffect, useState, useMemo } from "react";
import "./CSS/MaintenanceScreen.css";
import { styled, useTheme } from "@mui/material/styles";
import Drawer from "@mui/material/Drawer";
import CssBaseline from "@mui/material/CssBaseline";
import MuiAppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import List from "@mui/material/List";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import InboxIcon from "@mui/icons-material/MoveToInbox";
import MailIcon from "@mui/icons-material/Mail";
import axios from "axios";
import Button from "@mui/material/Button";
import { useUser } from "./Context/UserContext";
import { Alert, Snackbar } from "@mui/material";
import {
  Card,
  CardContent,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Container,
  Chip,
  TablePagination,
  Stack,
  ButtonGroup,
  ListItemAvatar,
  ListItemSecondaryAction,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  ToggleButton,
  ToggleButtonGroup,
  Badge,
  Fade,
  Zoom,
  FormControlLabel,
  Checkbox,
  AlertTitle,
} from "@mui/material";
import {
  CalendarMonth as CalendarIcon,
  TrendingUp as TrendingUpIcon,
  Analytics as AnalyticsIcon,
  CompareArrows as CompareIcon,
  ExpandMore as ExpandMoreIcon,
  CheckCircle as CheckCircleIcon,
  Close as CloseIcon,
  DateRange as DateRangeIcon,
  Timeline as TimelineIcon,
  Assessment as AssessmentIcon,
  PieChart as PieChartIcon,
  BarChart as BarChartIcon,
  ShowChart as ShowChartIcon,
  BubbleChart as BubbleChartIcon,
  Download as DownloadIcon,
  Circle as CircleIcon,
} from "@mui/icons-material";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { tr } from "date-fns/locale";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  BarChart,
  Bar,
  PieChart,
  Pie,
  Cell,
} from "recharts";
import {
  Tooltip as RechartsTooltip,
  Radar,
  RadarChart,
  PolarGrid,
  PolarAngleAxis,
  PolarRadiusAxis,
} from "recharts";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import dayjs from "dayjs";

import InfoIcon from "@mui/icons-material/Info";
import { Search } from "lucide-react";
import * as XLSX from "xlsx";
import { useNavigate } from "react-router-dom";
import Avatar from "@mui/material/Avatar";
import "./CSS/UserReport.css";
import { Image as ImageIcon } from "lucide-react";
import { saveAs } from "file-saver";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { Pagination } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import CompareArrowsIcon from "@mui/icons-material/CompareArrows";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import SearchIcon from "@mui/icons-material/Search";
import utc from "dayjs/plugin/utc";
import { use } from "react";
import PeopleIcon from "@mui/icons-material/People";
import StoreIcon from "@mui/icons-material/Store";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import VisibilityIcon from "@mui/icons-material/Visibility";
import DateRangeTwoToneIcon from "@mui/icons-material/DateRangeTwoTone";
import timezone from "dayjs/plugin/timezone";
import {
  format,
  startOfWeek,
  endOfWeek,
  addWeeks,
  isSameWeek,
  getWeek,
  getYear,
} from "date-fns";
import AddIcon from "@mui/icons-material/Add";
import RefreshIcon from '@mui/icons-material/Refresh';
import DashboardIcon from '@mui/icons-material/Dashboard';
import TableChartIcon from '@mui/icons-material/TableChart';

dayjs.extend(utc);
dayjs.extend(timezone);

const drawerWidth = 240;

const Main = styled("main", { shouldForwardProp: (prop) => prop !== "open" })(
  ({ theme }) => ({
    flexGrow: 1,
    padding: theme.spacing(3),
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    marginLeft: `-${drawerWidth}px`,
    variants: [
      {
        props: ({ open }) => open,
        style: {
          transition: theme.transitions.create("margin", {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.enteringScreen,
          }),
          marginLeft: 0,
        },
      },
    ],
  })
);

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme }) => ({
  transition: theme.transitions.create(["margin", "width"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  variants: [
    {
      props: ({ open }) => open,
      style: {
        width: `calc(100% - ${drawerWidth}px)`,
        marginLeft: `${drawerWidth}px`,
        transition: theme.transitions.create(["margin", "width"], {
          easing: theme.transitions.easing.easeOut,
          duration: theme.transitions.duration.enteringScreen,
        }),
      },
    },
  ],
}));

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
  justifyContent: "flex-end",
}));

const UserReports = () => {
  let status = "1";
  let path =
    status === "0" ? "http://localhost:3003" : "https://outlettee.com:3003";

  const theme = useTheme();
  const navigate = useNavigate();
  const [open, setOpen] = React.useState(true);
  const [selectedMenu, setSelectedMenu] = useState("");
  const [userInfos, setUserInfos] = useState([]);
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [alertSeverity, setAlertSeverity] = useState("success");
  const { user } = useUser();
  console.log(user);
  const COLORS = [
    "#FA8072", // Somon
    "#FF5733", // Turuncu-kırmızı
    "#FFBD33", // Altın sarısı
    "#75FF33", // Açık yeşil
    "#33FF57", // Yeşil ton
    "#33FFBD", // Turkuaz ton
    "#33DBFF", // Açık mavi
    "#3375FF", // Mavi
    "#5733FF", // Mor ton
    "#BD33FF", // Eflatun
    "#FF33DB", // Pembe ton
    "#FF3375", // Pembe-kırmızı
    "#FF3333", // Kırmızı
    "#FF6F61", // Mercan
    "#FFD700", // Altın
    "#ADFF2F", // Yeşil-sarı
    "#7FFF00", // Chartreuse
    "#00FA9A", // Orman yeşili
    "#00CED1", // Koyu Turkuaz
    "#1E90FF", // Dodger Mavisi
    "#4169E1", // Kraliyet Mavisi
    "#8A2BE2", // Mavi-mor
    "#9400D3", // Koyu mor
    "#C71585", // Orkide
    "#FF1493", // Pembe
    "#FF7F50", // Mercan
    "#CD5C5C", // Koyu mercan
    "#F08080", // Açık mercan
    "#DBFF33", // Sarı-yeşil
    "#FF00FF", // Fuşya
  ];

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };
  const handleMenuClick = (menu) => {
    setSelectedMenu(menu); // Menü tıklamalarını yakala
  };

  const [selectedUser, setSelectedUser] = useState("all");
  const [selectedShop, setSelectedShop] = useState("all");
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [selectedShopData, setSelectedShopData] = useState("all");
  const [data, setData] = useState([]);
  const [userData, setUserData] = useState([]);

  const [shopExpensesData, setShopExpensesData] = useState([]);
  const [userEffortsFees, setUserEffortsFees] = useState([]);

  const fetchUserFee = async () => {
    try {
      const response = await axios.post(path + "/api/AllEffortsFees", {
        UserID: user?.ID,
      });
      console.log("User Efforts Fees:", response.data);
      const parsedData = response.data;
      console.log(response.data);
      if (parsedData && parsedData.length > 0) {
        const updatedEfforts = userData.map((user) => {
          const existingEffort = parsedData.find(
            (effort) => effort.userId === user.UserID
          );

          return {
            userId: user.UserID,
            userName: user.UserName,
            effortType1: existingEffort?.effortType1 || "",
            effortType1Fee: existingEffort?.effortType1Fee || "",
            effortType2: existingEffort?.effortType2 || "",
            effortType2Fee: existingEffort?.effortType2Fee || "",
          };
        });
        setUserEffortsFees(updatedEfforts);
      }
    } catch (error) {
      console.error("Error fetching shop data:", error);
    }
  };

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    fetchUserFee();

    const fetchShopExpenses = async () => {
      try {
        setShopExpensesData([]);
        const response = await axios.post(path + "/api/GetAllShopExpenses", {
          UserID: user?.ID,
        });
        const parsedData = response.data;
        console.log(parsedData);
        setShopExpensesData(parsedData);
      } catch (error) {
        console.error("Error fetching shop data:", error);
      }
    };
    fetchShopExpenses();

    const fetchShopAuth = async () => {
      try {
        const response = await axios.post(path + "/api/getUserShops", {
          UserID: user?.ID,
          UserIsAdmin: user?.Admin,
        });
        const options = response.data.data.map((shop) => ({
          value: shop.ShopName,
          label: shop.ShopName,
        }));
        setOptions(options);
        console.log("Shop Auth Data:", options);
      } catch (error) {
        console.error("Error fetching shop data:", error);
      }
    };
    fetchShopAuth();

    const fetchShop = async () => {
      try {
        setData([]);
        const response = await axios.post(path + "/api/GetAllShopDatas", {
          UserID: user?.ID,
          isAdmin: user?.Admin,
        });
        const parsedData = response.data;
        console.log(parsedData);
        setData(parsedData);
      } catch (error) {
        console.error("Error fetching shop data:", error);
      }
    };
    fetchShop();
  }, []);

  const [options, setOptions] = useState([]);

  // Benzersiz kullanıcı ve mağaza listelerini oluştur
  const users = [...new Set(userData.map((item) => item.UserName))];
  const shops = [...new Set(userData.map((item) => item.Shop))];
  console.log("Users:", users);
  console.log("Shops:", shops);
  const filteredData = useMemo(() => {
    return userData.filter((item) => {
      const userMatch =
        selectedUser === "all" || item.UserName === selectedUser;
      const shopMatch = selectedShop === "all" || item.Shop === selectedShop;

      const itemDate = new Date(item.EffortDate);
      itemDate.setHours(0, 0, 0, 0);

      let dateMatch = true;

      if (startDate) {
        const startDateObj = new Date(startDate);
        startDateObj.setHours(0, 0, 0, 0);
        dateMatch = dateMatch && itemDate >= startDateObj;
      }

      if (endDate) {
        const endDateObj = new Date(endDate);
        endDateObj.setHours(0, 0, 0, 0);
        dateMatch = dateMatch && itemDate <= endDateObj;
      }

      return userMatch && shopMatch && dateMatch;
    });
  }, [selectedUser, selectedShop, userData, startDate, endDate]);

  const convertTimeSummaryToHours = (timeSummary) => {
    const [hours, minutes] = timeSummary.split(":").map(Number);
    const totalMinutes = hours * 60 + minutes;
    const exactHours = totalMinutes / 60; // Yuvarlama YOK
    return exactHours;
  };

  const totalCalculations = useMemo(() => {
    const calculations = filteredData.reduce(
      (total, item) => {
        const hours = convertTimeSummaryToHours(item.TimeSummary);

        // Kullanıcının fee bilgilerini bul
        const userFees = userEffortsFees.find(
          (fee) => fee.userId === item.UserID
        );

        if (!userFees) return total;

        // Shop'a göre fee seçimi ve hesaplama
        if (item.Shop === "Arge") {
          if (user.Admin === 1 || user.Username === selectedUser) {
            const hourlyFee = parseFloat(userFees.effortType2Fee);
            return {
              ...total,
              argeHours: total.argeHours + hours,
              argeCost: total.argeCost + hours * hourlyFee,
              hours: total.hours + hours,
              cost: total.cost + hours * hourlyFee,
            };
          } else {
            return {
              ...total,
              argeHours: total.argeHours + hours,
              argeCost: total.argeCost + 0, // ARGE maliyeti sıfır
              hours: total.hours + hours,
              cost: total.cost + 0, // ARGE için maliyet eklenmez
            };
          }
        } else {
          const hourlyFee = parseFloat(userFees.effortType1Fee);
          return {
            ...total,
            otherHours: total.otherHours + hours,
            otherCost: total.otherCost + hours * hourlyFee,
            hours: total.hours + hours,
            cost: total.cost + hours * hourlyFee,
          };
        }
      },
      {
        hours: 0,
        cost: 0,
        argeHours: 0,
        argeCost: 0,
        otherHours: 0,
        otherCost: 0,
      }
    );

    return {
      totalWorkHours: calculations.hours.toFixed(2),
      totalCost: calculations.cost.toFixed(2),
      argeWorkHours: calculations.argeHours.toFixed(2),
      argeCost: calculations.argeCost.toFixed(2),
      otherWorkHours: calculations.otherHours.toFixed(2),
      otherCost: calculations.otherCost.toFixed(2),
    };
  }, [filteredData, userEffortsFees, user, selectedUser]);

  const shopCalculations = useMemo(() => {
    const calculations = {};

    filteredData.forEach((item) => {
      if (item.Shop === "") return;

      const hours = convertTimeSummaryToHours(item.TimeSummary);
      const userFees = userEffortsFees.find(
        (fee) => fee.userId === item.UserID
      );

      if (!userFees) return;

      const hourlyFee =
        item.Shop === "ARGE"
          ? parseFloat(userFees.effortType2Fee)
          : parseFloat(userFees.effortType1Fee);

      if (!calculations[item.Shop]) {
        calculations[item.Shop] = { hours: 0, cost: 0 };
      }

      calculations[item.Shop].hours += hours;
      calculations[item.Shop].cost += hours * hourlyFee;
    });

    return Object.entries(calculations).map(([shop, calc]) => ({
      shop,
      hours: Number(calc.hours.toFixed(2)),
      cost: Number(calc.cost.toFixed(2)),
    }));
  }, [filteredData, userEffortsFees]);

  const totalWorkHours = useMemo(() => {
    return filteredData
      .reduce((total, item) => {
        return total + convertTimeSummaryToHours(item.TimeSummary);
      }, 0)
      .toFixed(2);
  }, [filteredData]);

  const shopHours = useMemo(() => {
    const hours = {};
    filteredData.forEach((item) => {
      if (item.Shop === "") {
        return;
      }
      const timeSpent = convertTimeSummaryToHours(item.TimeSummary);
      hours[item.Shop] = (hours[item.Shop] || 0) + timeSpent;
    });

    return Object.entries(hours).map(([shop, hours]) => ({
      shop,
      hours: Number(hours.toFixed(2)),
    }));
  }, [filteredData]);

  const dailyEfforts = useMemo(() => {
    const effortsByDate = {};
    filteredData.forEach((item) => {
      const date = new Date(item.EffortDate).toLocaleDateString();
      const timeSpent = convertTimeSummaryToHours(item.TimeSummary);
      effortsByDate[date] = (effortsByDate[date] || 0) + timeSpent;
    });
    return Object.entries(effortsByDate).map(([date, hours]) => ({
      date,
      hours: Number(hours.toFixed(2)),
    }));
  }, [filteredData]);

  const taskDistribution = useMemo(() => {
    const tasks = {};
    filteredData.forEach((item) => {
      const taskList = item.SelectedEfforts.split(",");
      const timePerTask =
        convertTimeSummaryToHours(item.TimeSummary) / taskList.length;
      taskList.forEach((task) => {
        tasks[task.trim()] = (tasks[task.trim()] || 0) + timePerTask;
      });
    });
    return Object.entries(tasks).map(([name, value]) => ({
      name,
      value: Number(value.toFixed(2)),
    }));
  }, [filteredData]);

  const UserDetailReports = () => {
    return (
      <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={tr}>
        <Box sx={{ p: 3 }}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mb: 3,
            }}
          >
            <Typography variant="h4" component="h1">
              Efor Raporu
            </Typography>
          </Box>

          <Card sx={{ width: "100%", mb: 3, p: 2 }}>
            <CardContent
              sx={{
                display: "flex",
                flexWrap: "wrap",
                gap: 2,
                alignItems: "center",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  flexWrap: "wrap",
                  gap: 2,
                  alignItems: "center",
                }}
              >
                {/* Kullanıcı Seçimi */}
                <FormControl sx={{ minWidth: 200 }}>
                  <InputLabel>Kullanıcı</InputLabel>
                  <Select
                    value={selectedUser}
                    label="Kullanıcı"
                    onChange={(e) => setSelectedUser(e.target.value)}
                  >
                    <MenuItem value="all">Tüm Kullanıcılar</MenuItem>
                    {users.map((user) => (
                      <MenuItem key={user} value={user}>
                        {user}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>

                {/* Mağaza Seçimi */}
                <FormControl sx={{ minWidth: 200 }}>
                  <InputLabel>Mağaza</InputLabel>
                  <Select
                    value={selectedShop}
                    label="Mağaza"
                    onChange={(e) => setSelectedShop(e.target.value)}
                  >
                    <MenuItem value="all">Tüm Mağazalar</MenuItem>
                    {shops.map((shop) => (
                      <MenuItem key={shop} value={shop}>
                        {shop}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>

                {/* Başlangıç Tarihi */}
                <DatePicker
                  label="Başlangıç Tarihi"
                  value={startDate}
                  onChange={(newValue) => setStartDate(newValue)}
                  renderInput={(params) => (
                    <TextField {...params} sx={{ minWidth: 180 }} />
                  )}
                />

                {/* Bitiş Tarihi */}
                <DatePicker
                  label="Bitiş Tarihi"
                  value={endDate}
                  onChange={(newValue) => setEndDate(newValue)}
                  renderInput={(params) => (
                    <TextField {...params} sx={{ minWidth: 180 }} />
                  )}
                  minDate={startDate}
                />

                {/* Verileri Getir Butonu */}
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleFetchData}
                  disabled={loading}
                  sx={{ minWidth: 180, height: 56 }}
                >
                  {loading ? "Yükleniyor..." : "Verileri Getir"}
                </Button>
                {userData.length === 0 ? (
                  <Typography variant="h6" color="error">
                    Lütfen Başlangıç ve Bitiş Tarihlerini Seçiniz ve Verileri
                    Getir Butonuna Basınız
                  </Typography>
                ) : (
                  <Typography variant="h6" color="success">
                    Farklı Tarihte Veri Seçimi Yapabilirsiniz
                  </Typography>
                )}
              </Box>

              {/* Hata Mesajı */}
              {error && (
                <Typography color="error" sx={{ mt: 2, textAlign: "center" }}>
                  {error}
                </Typography>
              )}
            </CardContent>
          </Card>

          <Card sx={{ mb: 3 }}>
            <CardContent>
              <Typography variant="h6" color="primary">
                Toplam Çalışma Süresi: {totalWorkHours} saat
              </Typography>

              {(user.Admin === 1 || user.Username === selectedUser) && (
                <Typography variant="h6" color="secondary">
                  Toplam Maliyet: {totalCalculations.totalCost} USD
                  <Typography
                    component="span"
                    sx={{
                      color: "warning.main", // sarı renk
                      fontSize: "0.8em", // ana yazıdan daha küçük
                      marginLeft: 1, // sol boşluk
                    }}
                  >
                    (ARGE: {totalCalculations.argeCost} USD, Diğer:{" "}
                    {totalCalculations.otherCost} USD)
                  </Typography>
                </Typography>
              )}
            </CardContent>
          </Card>

          <Grid container spacing={3}>
            <Grid item xs={12} md={6}>
              <Card>
                <CardContent>
                  <Typography variant="h6" gutterBottom>
                    Günlük Efor Dağılımı
                  </Typography>
                  <Box sx={{ height: 300 }}>
                    <ResponsiveContainer width="100%" height="100%">
                      <LineChart data={dailyEfforts}>
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis dataKey="date" />
                        <YAxis />
                        <Tooltip />
                        <Legend />
                        <Line
                          type="monotone"
                          dataKey="hours"
                          stroke="#1976d2"
                          name="Saat"
                        />
                      </LineChart>
                    </ResponsiveContainer>
                  </Box>
                </CardContent>
              </Card>
            </Grid>

            <Grid item xs={12} md={6}>
              <Card>
                <CardContent>
                  <Typography variant="h6" gutterBottom>
                    Mağaza Bazlı Toplam Efor
                  </Typography>
                  <Box sx={{ height: 300 }}>
                    <ResponsiveContainer width="100%" height="100%">
                      <BarChart data={shopHours}>
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis dataKey="shop" />
                        <YAxis />
                        <Tooltip />
                        <Legend />
                        <Bar
                          dataKey="hours"
                          fill="#2e7d32"
                          name="Toplam Saat"
                        />
                      </BarChart>
                    </ResponsiveContainer>
                  </Box>
                </CardContent>
              </Card>
            </Grid>

            <Grid item xs={12} md={6}>
              <Card>
                <CardContent>
                  <Typography variant="h6" gutterBottom>
                    Görev Dağılımı
                  </Typography>
                  <Box sx={{ height: 300 }}>
                    <ResponsiveContainer width="100%" height="100%">
                      <PieChart>
                        <Pie
                          data={taskDistribution}
                          dataKey="value"
                          nameKey="name"
                          cx="50%"
                          cy="50%"
                          outerRadius={100}
                          label
                        >
                          {/* Her dilim için farklı renk vermek */}
                          {taskDistribution.map((entry, index) => (
                            <Cell
                              key={`cell-${index}`}
                              fill={COLORS[index % COLORS.length]}
                            />
                          ))}
                        </Pie>
                        <Tooltip />
                      </PieChart>
                    </ResponsiveContainer>
                  </Box>
                </CardContent>
              </Card>
            </Grid>

            <Grid item xs={12}>
              <Card>
                <CardContent>
                  <Typography variant="h6" gutterBottom>
                    Detaylı Efor Listesi
                  </Typography>
                  <EffortTable
                    filteredData={filteredData}
                    onUpdateEffort={async (updatedEffort) => {}}
                  />
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        </Box>
      </LocalizationProvider>
    );
  };

  const EffortTable = ({ filteredData, onUpdateEffort }) => {
    const [editDialogOpen, setEditDialogOpen] = useState(false);
    const [detailsDialogOpen, setDetailsDialogOpen] = useState(false);
    const [selectedEffort, setSelectedEffort] = useState(null);
    const [searchTerm, setSearchTerm] = useState("");
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(20);
    const [screenshotsDialogOpen, setScreenshotsDialogOpen] = useState(false);

    // Excel export için fonksiyon
    const exportToExcel = () => {
      // Excel'e aktarılacak verileri hazırla - tüm veriler
      const dataToExport = searchedData.map((item) => ({
        Tarih: new Date(item.EffortDate).toLocaleDateString(),
        Kullanıcı: item.UserName,
        Mağaza: item.Shop,
        Başlangıç: item.StartHour,
        Bitiş: item.EndHour,
        "Toplam Süre": item.TimeSummary,
        Görevler:
          item.SelectedEfforts === "DIGER"
            ? `${item.SelectedEfforts} -> ${item.Explanation}`
            : item.SelectedEfforts,
        Açıklama: item.Explanation || "",
      }));

      const ws = XLSX.utils.json_to_sheet(dataToExport);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Efor Raporu");

      const wscols = [
        { wch: 15 },
        { wch: 20 },
        { wch: 20 },
        { wch: 10 },
        { wch: 10 },
        { wch: 12 },
        { wch: 40 },
        { wch: 50 },
      ];
      ws["!cols"] = wscols;

      XLSX.writeFile(
        wb,
        `Efor_Raporu_${new Date()
          .toLocaleDateString()
          .replace(/\//g, "-")}.xlsx`
      );
    };

    const handleScreenshotsClick = (effort) => {
      setSelectedEffort(effort);
      setScreenshotsDialogOpen(true);
    };

    const handleSearchChange = (event) => {
      setSearchTerm(event.target.value);
    };

    const handleChangePage = (event, newPage) => {
      setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
      setRowsPerPage(parseInt(event.target.value, 10));
      setPage(0);
    };
    const searchedData = filteredData
      .filter((item) =>
        Object.values(item).some((value) =>
          value?.toString().toLowerCase().includes(searchTerm.toLowerCase())
        )
      )
      .sort((a, b) => {
        // Tarihleri karşılaştırma (yeniden eskiye)
        const dateA = new Date(a.EffortDate);
        const dateB = new Date(b.EffortDate);

        // Aynı tarihler için saat karşılaştırması
        if (dateA.getTime() === dateB.getTime()) {
          const timeA = a.StartHour.split(":").map(Number);
          const timeB = b.StartHour.split(":").map(Number);

          // Saat karşılaştırması
          if (timeA[0] !== timeB[0]) {
            return timeB[0] - timeA[0];
          }
          // Dakika karşılaştırması
          return timeB[1] - timeA[1];
        }

        return dateB.getTime() - dateA.getTime();
      });
    // Filtrelenmiş ve sayfalama uygulanmış veriler
    const paginatedData = searchedData.slice(
      page * rowsPerPage,
      page * rowsPerPage + rowsPerPage
    );
    // Arama terimini kullanarak verileri filtrele

    const handleEditClick = (effort) => {
      setSelectedEffort(effort);
      setEditDialogOpen(true);
    };

    const handleDetailsClick = (effort) => {
      console.log(effort);
      setSelectedEffort(effort);
      setDetailsDialogOpen(true);
    };

    const handleSave = async (updatedEffort) => {
      console.log(updatedEffort);
      try {
        const indexID = updatedEffort.Id;
        const selectedShop = updatedEffort.Shop;
        const UserID = user?.ID;
        const username = user?.Username;
        const startDate = dayjs(updatedEffort.EffortDate).format("DD/MM/YYYY");
        const startTime = updatedEffort.StartHour;
        const endTime = updatedEffort.EndHour;
        const description = updatedEffort.Explanation;
        const storeLinks = updatedEffort.ShopLinks;
        const sellerLinks = updatedEffort.PurchLinks;
        const SelectedEfforts = updatedEffort.SelectedEfforts.map(
          (item) => `${item}`
        ).join(", ");

        const start = dayjs(`1970-01-01T${updatedEffort.StartHour}`);
        let end = dayjs(`1970-01-01T${updatedEffort.EndHour}`);

        if (end.isBefore(start)) {
          end = end.add(1, "day");
        }

        const totalMinutes = end.diff(start, "minute");
        const hours = Math.floor(totalMinutes / 60); // 2
        const minutes = totalMinutes % 60; // 5

        // Dakika kısmını 2 basamakla padStart yapalım
        const formattedMinutes = String(minutes).padStart(2, "0"); // "05"
        const TimeSummary = `${hours}:${formattedMinutes}`;

        console.log(TimeSummary); // "2:05"
        // Zorunlu alanlar dolu mu diye kontrol
        if (!startDate || !startTime || !endTime) {
          setAlertSeverity("error");
          setAlertMessage("Lütfen tüm zorunlu alanları doldurunuz!");
          setAlertOpen(true);
          return;
        }

        // Kullanıcı bilgisi var mı?
        if (!UserID || !username) {
          setAlertSeverity("error");
          setAlertMessage(
            "Beklenmedik Bir Hata Oluştu. Lütfen Yöneticinizle İletişime Geçiniz!"
          );
          setAlertOpen(true);
          return;
        }

        // Sunucuya güncelleme isteği at
        const response = await axios.post(`${path}/api/UpdateFormData`, {
          indexID,
          UserID,
          username,
          selectedShop,
          startDate,
          startTime,
          endTime,
          SelectedEfforts,
          description,
          storeLinks,
          sellerLinks,
          TimeSummary,
        });

        // Başarılı ise alert göster
        setAlertSeverity("success");
        setAlertMessage("Efor başarıyla güncellendi.");
        setAlertOpen(true);
      } catch (error) {
        setAlertSeverity("error");
        setAlertMessage("Efor güncellenirken bir hata oluştu." + error);
        setAlertOpen(true);
      }
    };
    const DetailsDialog = ({ open, onClose, effort }) => {
      if (!effort) return null;

      // Helper function to check if base64 string is valid
      const isValidBase64 = (str) => {
        if (!str) return false;
        try {
          return str.startsWith("data:image") || btoa(atob(str)) === str;
        } catch (err) {
          return false;
        }
      };

      // Get valid images from effort
      const images = ["Image1", "Image2", "Image3"]
        .map((key) => effort[key])
        .filter(isValidBase64);

      const separateLinks = (linkString) => {
        if (!linkString) return [];

        // URL'leri düzgün ayırmak için düzenleme yap
        const urlPattern = /(https?:\/\/[^\s]+)/g;
        return (
          linkString.replace(/(https)(?=:\/\/)/g, " $1").match(urlPattern) || []
        );
      };

      const LinkTable = ({ title, links }) => (
        <div className="space-y-4">
          <h3 className="text-base font-medium">{title}</h3>
          {links.length > 0 ? (
            <table className="w-full border border-gray-300">
              <thead>
                <tr className="bg-gray-200">
                  <th className="border border-gray-300 px-4 py-2">Linkler</th>
                </tr>
              </thead>
              <tbody>
                {links.map((link, index) => (
                  <tr key={index} className="border-b border-gray-300">
                    <td className="border border-gray-300 px-4 py-2">
                      <a
                        href={link}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-blue-600 hover:text-blue-800 hover:underline"
                      >
                        {link}
                      </a>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <p className="text-gray-500">Link bulunmuyor</p>
          )}
        </div>
      );

      return (
        <Dialog open={open}>
          <DialogTitle className="text-lg font-semibold">
            Ayrıntılı Bilgiler
          </DialogTitle>
          <DialogContent>
            <div className="space-y-6 p-4">
              <div className="space-y-2">
                <h3 className="text-base font-medium">Adet Sayısı:</h3>
                <p>{effort.Piace}</p>
              </div>
              <div className="space-y-6">
                <LinkTable
                  title="Mağaza Linkleri"
                  links={separateLinks(effort.ShopLinks)}
                />
                <LinkTable
                  title="Satıcı Linkleri"
                  links={separateLinks(effort.PurchLinks)}
                />
              </div>

              {/* Resimler */}
              {images.length > 0 && (
                <div className="space-y-2">
                  <h3 className="text-base font-medium">Resimler:</h3>
                  <div className="grid grid-cols-1 gap-4 place-items-center">
                    {images.map((image, index) => (
                      <div key={index} className="relative">
                        <Box
                          component="img"
                          src={
                            image.startsWith("data:image")
                              ? image
                              : `data:image/jpeg;base64,${image}`
                          }
                          alt={`Resim ${index + 1}`}
                          sx={{
                            width: 400,
                            height: 400,
                            objectFit: "contain",
                            borderRadius: "8px",
                            backgroundColor: "gray",
                          }}
                          onError={(e) => {
                            e.target.src = "/api/placeholder/200/200";
                          }}
                        />
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
          </DialogContent>
          <DialogActions>
            <Button onClick={onClose} variant="outline">
              Kapat
            </Button>
          </DialogActions>
        </Dialog>
      );
    };
    const effortOptions = [
      "MESAJLARA CEVAP",
      "CUSTOMHUB",
      "CUSTOM ORDER HAZIRLANMASI",
      "URUN BULMA",
      "URUN YUKLEME",
      "MAGAZA GENEL KONTROL",
      "TOPLANTI",
      "PIYASA ARSTIRMASI AR-GE",
      "REKLAM OPTIMIZASYONU",
      "URETIM TAKIP VE KONTROL",
      "DIZAYN CIZIMI",
      "MOCKUP EKLEME",
      "TRADEMARK KONTROLU",
      "ARGE",
      "FASHION FOLLOW",
      "YONETIM VE KONTROL",
      "DIGER",
    ];

    const ScreenshotsDialog = ({ open, onClose, effort }) => {
      const [screenshots, setScreenshots] = useState([]);
      const [loading, setLoading] = useState(false);
      const [error, setError] = useState(null);
      const [page, setPage] = useState(0);
      const [itemsPerPage] = useState(60);

      const fetchScreenshots = async () => {
        if (!effort) return;

        setLoading(true);
        setError(null);
        setPage(0);

        try {
          // Türkiye saatine çevir
          const turkeyTimeZone = "Europe/Istanbul";

          const effortDateLocal = dayjs(effort.EffortDate)
            .tz(turkeyTimeZone)
            .format("YYYY-MM-DD");
          const startDateTime = dayjs(
            `${effortDateLocal} ${effort.StartHour}`,
            "YYYY-MM-DD HH:mm"
          )
            .tz(turkeyTimeZone)
            .format("YYYY-MM-DD HH:mm:ss");

          const endDateTime = dayjs(
            `${effortDateLocal} ${effort.EndHour}`,
            "YYYY-MM-DD HH:mm"
          )
            .tz(turkeyTimeZone)
            .format("YYYY-MM-DD HH:mm:ss");

          const response = await axios.post(`${path}/api/GetScreenShots`, {
            startDate: startDateTime,
            endDate: endDateTime,
            userId: effort.UserID,
            timezone: turkeyTimeZone,
          });

          setScreenshots(response.data);
          console.log("Screenshots fetched:", response.data);
        } catch (err) {
          console.error("Screenshot fetch error:", err);
          setError("Ekran görüntüleri alınırken bir hata oluştu.");
        } finally {
          setLoading(false);
        }
      };

      useEffect(() => {
        if (open) {
          fetchScreenshots();
        }
      }, [open, effort]);

      // Timeline chart için veri hazırlama
     const prepareTimelineData = () => {
            if (!screenshots.length) return [];

            const timelineData = [];

            // Backend'den gelen tarihleri Türkiye saatinde parse et
            const startTime = dayjs(screenshots[0].UploadDate, "YYYY-MM-DD HH:mm:ss")
              .tz("Europe/Istanbul");
            const endTime = dayjs(screenshots[screenshots.length - 1].UploadDate, "YYYY-MM-DD HH:mm:ss")
              .tz("Europe/Istanbul");

            // Her dakika için bir entry oluştur
            let currentTime = startTime.startOf("minute");
            while (currentTime.isBefore(endTime) || currentTime.isSame(endTime, "minute")) {
              // Bu dakikada screenshot var mı kontrol et
              const screenshotInMinute = screenshots.find((s) =>
                dayjs(s.UploadDate, "YYYY-MM-DD HH:mm:ss")
                  .tz("Europe/Istanbul")
                  .isSame(currentTime, "minute")
              );

              timelineData.push({
                time: currentTime.format("HH:mm"),
                fullTime: currentTime.format("DD.MM.YYYY HH:mm"),
                type: screenshotInMinute ? parseInt(screenshotInMinute.Type) : 0,
                hasScreenshot: !!screenshotInMinute,
              });

              currentTime = currentTime.add(1, "minute");
            }

            return timelineData;
          };

      const getTypeColor = (type) => {
        switch (type) {
          case 1:
            return "#4CAF50"; // Yeşil - Aktif
          case 2:
            return "#FFC107"; // Sarı - Boşta/Alt tab
          case 3:
            return "#F44336"; // Kırmızı - Bağlı değil
          default:
            return "#E0E0E0"; // Gri - Veri yok
        }
      };

      const getTypeLabel = (type) => {
        switch (type) {
          case 1:
            return "Aktif";
          case 2:
            return "Boşta/Alt Tab";
          case 3:
            return "Bağlı Değil";
          default:
            return "Veri Yok";
        }
      };

      const timelineData = prepareTimelineData();

      // Sayfalama hesaplama
      const pageCount = Math.ceil(screenshots.length / itemsPerPage);
      const currentPageItems = screenshots.slice(
        page * itemsPerPage,
        (page + 1) * itemsPerPage
      );

      return (
        <Dialog open={open} onClose={onClose} maxWidth="xl" fullWidth>
          <DialogTitle>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Typography>Ekran Görüntüleri</Typography>
              {screenshots.length > 0 && (
                <Typography variant="body2" color="text.secondary">
                  Toplam: {screenshots.length} görüntü
                </Typography>
              )}
            </Box>
          </DialogTitle>
          <DialogContent>
            {loading ? (
              <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                height={400}
              >
                <Typography sx={{ ml: 2 }}>Yükleniyor...</Typography>
              </Box>
            ) : error ? (
              <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                color="error.main"
              >
                {error}
              </Box>
            ) : screenshots.length === 0 ? (
              <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                color="text.secondary"
              >
                Bu zaman aralığında ekran görüntüsü bulunmamaktadır.
              </Box>
            ) : (
              <>
                {/* Timeline Chart */}
                <Box sx={{ mb: 3 }}>
                  <Typography variant="h6" sx={{ mb: 2 }}>
                    Aktivite Zaman Çizelgesi
                  </Typography>

                  {/* Legend */}
                  <Box
                    sx={{ display: "flex", gap: 2, mb: 2, flexWrap: "wrap" }}
                  >
                    {[
                      { type: 1, label: "Aktif" },
                      { type: 2, label: "Boşta/Alt Tab" },
                      { type: 3, label: "Bağlı Değil" },
                      { type: 0, label: "Veri Yok" },
                    ].map(({ type, label }) => (
                      <Box
                        key={type}
                        sx={{ display: "flex", alignItems: "center", gap: 1 }}
                      >
                        <Box
                          sx={{
                            width: 12,
                            height: 12,
                            backgroundColor: getTypeColor(type),
                            borderRadius: "2px",
                          }}
                        />
                        <Typography variant="caption">{label}</Typography>
                      </Box>
                    ))}
                  </Box>

                  {/* Timeline */}
                  <Box
                    sx={{
                      border: "1px solid #e0e0e0",
                      borderRadius: 1,
                      p: 2,
                      maxHeight: 200,
                      overflowY: "auto",
                    }}
                  >
                    <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
                      {timelineData.map((item, index) => (
                        <Box
                          key={index}
                          sx={{
                            width: 8,
                            height: 20,
                            backgroundColor: getTypeColor(item.type),
                            borderRadius: "2px",
                            cursor: "pointer",
                            transition: "all 0.2s",
                            "&:hover": {
                              transform: "scale(1.2)",
                              boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
                            },
                          }}
                          title={`${item.fullTime} - ${getTypeLabel(
                            item.type
                          )}`}
                        />
                      ))}
                    </Box>

                    {/* Saat göstergeleri */}
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        mt: 1,
                        fontSize: "0.7rem",
                        color: "text.secondary",
                      }}
                    >
                      {timelineData.length > 0 && (
                        <>
                          <span>{timelineData[0].time}</span>
                          {timelineData.length > 60 && (
                            <span>
                              {
                                timelineData[
                                  Math.floor(timelineData.length / 2)
                                ].time
                              }
                            </span>
                          )}
                          <span>
                            {timelineData[timelineData.length - 1].time}
                          </span>
                        </>
                      )}
                    </Box>
                  </Box>

                  {/* İstatistikler */}
                  <Box
                    sx={{ mt: 2, display: "flex", gap: 3, flexWrap: "wrap" }}
                  >
                    {[1, 2, 3].map((type) => {
                      const count = timelineData.filter(
                        (item) => item.type === type
                      ).length;
                      const percentage =
                        timelineData.length > 0
                          ? ((count / timelineData.length) * 100).toFixed(1)
                          : 0;

                      return (
                        <Box
                          key={type}
                          sx={{ display: "flex", alignItems: "center", gap: 1 }}
                        >
                          <Box
                            sx={{
                              width: 8,
                              height: 8,
                              backgroundColor: getTypeColor(type),
                              borderRadius: "50%",
                            }}
                          />
                          <Typography variant="body2">
                            {getTypeLabel(type)}: {count} dk ({percentage}%)
                          </Typography>
                        </Box>
                      );
                    })}
                  </Box>
                </Box>

                {/* Screenshots Grid */}
                <Box
                  sx={{
                    display: "grid",
                    gridTemplateColumns: "1fr",
                    gap: 3,
                    justifyItems: "center",
                    mt: 2,
                    mb: 2,
                  }}
                >
                  {currentPageItems.map((screenshot, index) => (
                    <Box
                      key={index}
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        width: "100%",
                        maxWidth: 1000,
                        border: "1px solid",
                        borderColor: "divider",
                        borderRadius: 2,
                        p: 2,
                        boxShadow: 1,
                        position: "relative",
                      }}
                    >
                      {/* Status indicator */}
                      <Box
                        sx={{
                          position: "absolute",
                          top: 8,
                          right: 8,
                          width: 12,
                          height: 12,
                          backgroundColor: getTypeColor(
                            parseInt(screenshot.Type)
                          ),
                          borderRadius: "50%",
                          border: "2px solid white",
                          boxShadow: "0 1px 3px rgba(0,0,0,0.3)",
                        }}
                        title={getTypeLabel(parseInt(screenshot.Type))}
                      />

                      <Box
                        sx={{
                          width: "100%",
                          maxHeight: 700,
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          overflow: "hidden",
                        }}
                      >
                        <Box
                          component="img"
                          src={screenshot.ScreenshotPath}
                          alt={`Ekran Görüntüsü ${index + 1}`}
                          sx={{
                            maxWidth: "100%",
                            height: "auto",
                            objectFit: "contain",
                          }}
                          onError={(e) => {
                            e.target.src = "/api/placeholder/400/300";
                          }}
                        />
                      </Box>
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          mt: 1,
                        }}
                      >
                       <Typography variant="caption" color="text.secondary">
                        
                         {dayjs.utc(screenshot.UploadDate).format("DD.MM.YYYY HH:mm:ss")}
                        </Typography>
                        <Typography variant="caption" color="text.secondary">
                          {screenshot.SystemUserName} -{" "}
                          {getTypeLabel(parseInt(screenshot.Type))}
                        </Typography>
                      </Box>
                    </Box>
                  ))}
                </Box>

                {screenshots.length > itemsPerPage && (
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      mt: 2,
                      mb: 2,
                    }}
                  >
                    <Pagination
                      count={pageCount}
                      page={page + 1}
                      onChange={(e, newPage) => setPage(newPage - 1)}
                      color="primary"
                      siblingCount={2}
                      boundaryCount={2}
                      showFirstButton
                      showLastButton
                    />
                  </Box>
                )}
              </>
            )}
          </DialogContent>
          <DialogActions>
            <Button onClick={onClose} variant="outlined">
              Kapat
            </Button>
          </DialogActions>
        </Dialog>
      );
    };

    
    return (
      <div className="space-y-4">
        {/* Arama Alanı */}

        <ScreenshotsDialog
          open={screenshotsDialogOpen}
          onClose={() => setScreenshotsDialogOpen(false)}
          effort={selectedEffort}
        />

        <EditEffortDialog
          open={editDialogOpen}
          onClose={() => setEditDialogOpen(false)}
          effort={selectedEffort || {}}
          onSave={handleSave}
          shops={shops || []}
          allEffortTypes={effortOptions || []}
        />

        {/* Details Dialog */}
        <DetailsDialog
          open={detailsDialogOpen}
          onClose={() => setDetailsDialogOpen(false)}
          effort={selectedEffort}
        />

        <Paper elevation={3} sx={{ p: 2, borderRadius: 2 }}>
          <Box
            display="flex"
            flexDirection={{ xs: "column", sm: "row" }}
            alignItems="center"
            justifyContent="space-between"
            gap={2}
          >
            <Box display="flex" alignItems="center" flexGrow={1} gap={1}>
              <SearchIcon sx={{ color: "gray.500" }} />
              <TextField
                fullWidth
                variant="outlined"
                placeholder="Ara..."
                value={searchTerm}
                onChange={handleSearchChange}
                size="small"
              />
            </Box>

            <Button
              variant="contained"
              color="success"
              onClick={exportToExcel}
              startIcon={<DownloadIcon />}
              sx={{ whiteSpace: "nowrap" }}
            >
              Excel'e Aktar
            </Button>
          </Box>
        </Paper>

        {/* Tablo */}
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>İşlemler</TableCell>
                <TableCell>Tarih</TableCell>
                <TableCell>Kullanıcı</TableCell>
                <TableCell>Mağaza</TableCell>
                <TableCell>Başlangıç</TableCell>
                <TableCell>Bitiş</TableCell>
                <TableCell>Toplam Süre</TableCell>
                <TableCell>Görevler</TableCell>
                <TableCell>Ayrıntılar</TableCell>
                {user.Admin === 1 && <TableCell>Ekran Görüntüleri</TableCell>}
              </TableRow>
            </TableHead>
            <TableBody>
              {paginatedData.map((item) => (
                <TableRow key={item.Id}>
                  <TableCell>
                    <IconButton
                      size="small"
                      onClick={() => handleEditClick(item)}
                      color="primary"
                    ></IconButton>
                  </TableCell>
                  <TableCell>
                    {new Date(item.EffortDate).toLocaleDateString()}
                  </TableCell>
                  <TableCell>{item.UserName}</TableCell>
                  <TableCell>{item.Shop}</TableCell>
                  <TableCell>{item.StartHour}</TableCell>
                  <TableCell>{item.EndHour}</TableCell>
                  <TableCell>{item.TimeSummary}</TableCell>
                  <TableCell>
                    {item.SelectedEfforts === "DIGER"
                      ? `${item.SelectedEfforts} -> ${item.Explanation}`
                      : item.SelectedEfforts}
                  </TableCell>
                  <TableCell>
                    <IconButton
                      size="small"
                      onClick={() => handleDetailsClick(item)}
                      color="info"
                    >
                      <InfoIcon />
                    </IconButton>
                  </TableCell>
                  {user.Admin === 1 && (
                    <TableCell>
                      <IconButton
                        size="small"
                        onClick={() => handleScreenshotsClick(item)}
                        color="secondary"
                      >
                        <ImageIcon />
                      </IconButton>
                    </TableCell>
                  )}
                </TableRow>
              ))}
            </TableBody>
          </Table>
          {/* Sayfalama */}
          <TablePagination
            component="div"
            count={searchedData.length}
            page={page}
            onPageChange={handleChangePage}
            rowsPerPage={rowsPerPage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            rowsPerPageOptions={[10, 20, 50]}
            labelRowsPerPage="Sayfa başına satır:"
            labelDisplayedRows={({ from, to, count }) =>
              `${from}-${to} arası, toplam: ${count}`
            }
          />
        </TableContainer>
      </div>
    );
  };
  const EditEffortDialog = ({
    effort,
    open,
    onClose,
    onSave,
    shops,
    allEffortTypes,
  }) => {
    const [formData, setFormData] = useState({
      StartHour: effort.StartHour || "",
      EndHour: effort.EndHour || "",
      Shop: effort.Shop || "",
      SelectedEfforts: Array.isArray(effort.SelectedEfforts)
        ? effort.SelectedEfforts
        : effort.SelectedEfforts?.split(",").map((item) => item.trim()) || [],
      Explanation: effort.Explanation || "",
      ShopLinks: effort.ShopLinks || "",
      PurchLinks: effort.PurchLinks || "",
    });

    const handleChange = (e) => {
      const { name, value } = e.target;
      if (name === "SelectedEfforts") {
        setFormData((prev) => ({
          ...prev,
          SelectedEfforts: typeof value === "string" ? value.split(",") : value,
        }));
      } else {
        setFormData((prev) => ({
          ...prev,
          [name]: value,
        }));
      }
    };

    const handleSubmit = () => {
      onSave({ ...effort, ...formData });
      onClose();
    };

    return (
      <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
        <DialogTitle>Efor Kaydını Güncelle</DialogTitle>
        <DialogContent>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              gap: 2,
              mt: 2,
            }}
          >
            <FormControl fullWidth sx={{}}>
              <TextField
                name="StartHour"
                label="Başlangıç Saati"
                type="time"
                value={formData.StartHour}
                onChange={handleChange}
                fullWidth
                InputLabelProps={{ shrink: true }}
                sx={{ mb: 2 }}
              />
            </FormControl>

            <FormControl fullWidth sx={{}}>
              <TextField
                name="EndHour"
                label="Bitiş Saati"
                type="time"
                value={formData.EndHour}
                onChange={handleChange}
                fullWidth
                InputLabelProps={{ shrink: true }}
              />
            </FormControl>
          </Box>
          <FormControl fullWidth sx={{ mb: 2 }}>
            <InputLabel>Mağaza</InputLabel>
            <Select
              name="Shop"
              value={formData.Shop}
              onChange={handleChange}
              label="Mağaza"
            >
              {shops.map((shop, index) => (
                <MenuItem key={index} value={shop}>
                  {shop}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <FormControl fullWidth sx={{ mb: 2 }}>
            <InputLabel>Yapılan İşler</InputLabel>
            <Select
              name="SelectedEfforts"
              multiple
              value={formData.SelectedEfforts}
              onChange={handleChange}
              label="Yapılan İşler"
            >
              {allEffortTypes.map((effort, index) => (
                <MenuItem key={index} value={effort}>
                  {effort}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <FormControl fullWidth sx={{ mb: 2 }}>
            <TextField
              name="Explanation"
              label="Açıklama"
              multiline
              rows={4}
              value={formData.Explanation}
              onChange={handleChange}
              fullWidth
            />
          </FormControl>

          <FormControl fullWidth sx={{ mb: 2 }}>
            <TextField
              name="storeLinks"
              label="Mağaza Linkleri"
              multiline
              rows={2}
              value={formData.ShopLinks}
              onChange={handleChange}
              fullWidth
            />
          </FormControl>

          <FormControl fullWidth sx={{ mb: 2 }}>
            <TextField
              name="sellerLinks"
              label="Satıcı Linkleri"
              multiline
              rows={2}
              value={formData.PurchLinks}
              onChange={handleChange}
              fullWidth
            />
          </FormControl>
        </DialogContent>

        <DialogActions>
          <Button onClick={onClose} color="primary">
            İptal
          </Button>
          <Button onClick={handleSubmit} color="primary" variant="contained">
            Güncelle
          </Button>
        </DialogActions>
      </Dialog>
    );
  };

  const calculateMetrics = (shop, startDate, endDate, userEarnings) => {
    const expenses = calculateExpenses(
      shop.SelectedShop,
      shop.StartDate,
      shop.EndDate
    ).toFixed(2);

    const etsyMoneyDeposit = (
      Math.abs(shop.salesSummaryDiff) -
      (Math.abs(shop.listingFeesDiff) +
        Math.abs(shop.marketingFeesDiff) +
        Math.abs(shop.ShippingFeesDiff))
    ).toFixed(2);

    const shippingExpenses = Math.abs(shop.ShippingFeesDiff);
    const totalSalesAmount = Math.abs(Number(shop.CSVSalesSummary));
    const totalRefundAmount = Math.abs(Number(shop.totalRefundsAmountsDiff));
    const totalMarketingFees = Math.abs(shop.marketingFeesDiff);
    const totalFees = Math.abs(shop.listingFeesDiff);
    const shippingFees = Math.abs(shop.ShippingFeesDiff);
    const tpcExpenses = (
      Math.abs(shop.productTotalSum) +
      Math.abs(shop.productCustomCost) +
      Math.abs(shop.returnAndExchange)
    ).toFixed(2);

    const formattedStartDate = shop.StartDate ? new Date(shop.StartDate) : null;
    const formattedEndDate = shop.EndDate ? new Date(shop.EndDate) : null;

    if (formattedStartDate) {
      formattedStartDate.setDate(formattedStartDate.getDate());
    }
    if (formattedEndDate) {
      formattedEndDate.setDate(formattedEndDate.getDate());
    }

    const StartDateFormat = formattedStartDate
      ? formattedStartDate.toISOString().split("T")[0]
      : "";
    const EndDateFormat = formattedEndDate
      ? formattedEndDate.toISOString().split("T")[0]
      : "";

    const userEarningsCalc = calculateUserEarningsInRange(
      shop.Responsible,
      StartDateFormat,
      EndDateFormat
    );

    const selectedEarnings =
      userEarningsCalc.shops?.[shop.SelectedShop]?.earnings.toFixed(2);

    const shopExpenses =
      Math.abs(shop.ShippingFeesCSV) +
      Math.abs(shop.productCustomCost) +
      Math.abs(shop.returnAndExchange) +
      Math.abs(shop.productTotalSum);

    const totalProfit = (
      Math.abs(shop.PaymentFee) -
      shopExpenses -
      expenses
    ).toFixed(2);

    const reelTotalProfit = (
      Math.abs(etsyMoneyDeposit) -
      shopExpenses -
      expenses
    ).toFixed(2);

    const lineTotalProfitViaUnit = (totalProfit / totalSalesAmount).toFixed(2);
    const lineReelProfitViaUnit = (reelTotalProfit / totalSalesAmount).toFixed(
      2
    );
    const lineTotalMarketingViaUnit = (
      totalMarketingFees / totalSalesAmount
    ).toFixed(2);
    const lineTotalFeeViaUnit = (totalFees / totalSalesAmount).toFixed(2);
    const lineShippingFeeViaUnit = (
      Math.abs(shop.ShippingFeesCSV) / totalSalesAmount
    ).toFixed(2);
    const lineExpenesViaUnit = (expenses / totalSalesAmount).toFixed(2);

    return {
      shopExpenses,
      totalProfit,
      etsyMoneyDeposit,
      shippingExpenses,
      totalSalesAmount,
      totalRefundAmount,
      totalMarketingFees,
      totalFees,
      shippingFees,
      tpcExpenses,
      expenses,
      StartDateFormat,
      EndDateFormat,
      selectedEarnings,
      reelTotalProfit,
      lineTotalProfitViaUnit,
      lineReelProfitViaUnit,
      lineTotalMarketingViaUnit,
      lineTotalFeeViaUnit,
      lineShippingFeeViaUnit,
      lineExpenesViaUnit,
    };
  };

  const calculateExpenses = (shop, start, end) => {
    const userStart = start ? new Date(start) : null;
    const userEnd = end ? new Date(end) : null;

    return shopExpensesData
      .filter((expense) => {
        return expense.shop === shop;
      })
      .reduce((total, expense) => {
        const expenseStart = new Date(expense.startDate);
        const expenseEnd = new Date(expense.endDate);

        if (!userStart || !userEnd) {
          return total + Number(expense.amount);
        }
        if (expenseEnd < userStart || expenseStart > userEnd) {
          return total;
        }

        const overlapStart =
          expenseStart < userStart ? userStart : expenseStart;
        const overlapEnd = expenseEnd > userEnd ? userEnd : expenseEnd;

        const totalDays =
          Math.ceil((expenseEnd - expenseStart) / (1000 * 3600 * 24)) + 1;
        const overlapDays =
          Math.ceil((overlapEnd - overlapStart) / (1000 * 3600 * 24)) + 1;

        if (overlapDays < 0) {
          return total;
        }

        const dailyCost = Number(expense.amount) / totalDays;
        const partialCost = dailyCost * overlapDays;

        return total + partialCost;
      }, 0);
  };

  const calculateUserEarningsInRange = (username, startDate, endDate) => {
    const userEarnings = {
      argeHours: 0,
      argeEarnings: 0,
      otherHours: 0,
      otherEarnings: 0,
      totalHours: 0,
      totalEarnings: 0,
      shops: {},
    };

    userData.forEach((record) => {
      // Kullanıcı adı eşleşmiyorsa atla
      if (record.UserName !== username) return;

      // Tarih filtresi
      const recordDate = new Date(record.EffortDate);
      recordDate.setHours(0, 0, 0, 0);

      if (startDate) {
        const start = new Date(startDate);
        start.setHours(0, 0, 0, 0);
        if (recordDate < start) return;
      }

      if (endDate) {
        const end = new Date(endDate);
        end.setHours(0, 0, 0, 0);
        if (recordDate > end) return;
      }

      // Süre hesaplama
      const [hours, minutes] = record.TimeSummary.split(":").map(Number);
      const durationHours = hours + minutes / 60;

      // Ücret bulma
      const userFee = userEffortsFees.find(
        (fee) => fee.userId === record.UserID
      );
      if (!userFee) return;

      // Kazanç hesaplama
      if (record.Shop === "Arge") {
        const rate = parseFloat(userFee.effortType2Fee) || 0;
        userEarnings.argeHours += durationHours;
        userEarnings.argeEarnings += durationHours * rate;
      } else {
        const rate = parseFloat(userFee.effortType1Fee) || 0;
        userEarnings.otherHours += durationHours;
        userEarnings.otherEarnings += durationHours * rate;

        // Mağaza detayları
        if (!userEarnings.shops[record.Shop]) {
          userEarnings.shops[record.Shop] = {
            hours: 0,
            earnings: 0,
          };
        }
        userEarnings.shops[record.Shop].hours += durationHours;
        userEarnings.shops[record.Shop].earnings += durationHours * rate;
      }

      // Toplamlar
      userEarnings.totalHours += durationHours;
      userEarnings.totalEarnings =
        userEarnings.argeEarnings + userEarnings.otherEarnings;
    });

    return userEarnings;
  };

  const ShopData = () => {
    const formatCurrency = (value) =>
      Number(value).toLocaleString("en-US", {
        style: "currency",
        currency: "USD",
      });

    const [selectedMetrics, setSelectedMetrics] = useState(() => {
      try {
        const saved = localStorage.getItem("shopData.selectedMetrics");
        return saved ? JSON.parse(saved) : ["totalProfit"];
      } catch {
        return ["totalProfit"];
      }
    });

    useEffect(() => {
      localStorage.setItem(
        "shopData.selectedMetrics",
        JSON.stringify(selectedMetrics)
      );
    }, [selectedMetrics]);

    const handleSelectedMetricsChange = (e) => {
      const { value } = e.target;
      setSelectedMetrics(
        Array.isArray(value) ? value : String(value).split(",")
      );
    };

    const metricOptions = [
      { field: "totalProfit", headerName: "Kar/Zarar" },
      { field: "etsyMoneyDeposit", headerName: "Etsy Yatması Beklenen Para" },
      { field: "totalSales", headerName: "Toplam Satış" },
      { field: "PaymentFee", headerName: "Etsy Yatan Para" },
      { field: "CSVSalesSummary", headerName: "Toplam Satış Adedi" },
      { field: "totalRefundsAmounts", headerName: "İadeler" },
      { field: "listingFeesDiff", headerName: "Liste Ücretleri" },
      { field: "marketingFeesDiff", headerName: "Pazarlama Ücretleri" },
      { field: "ShippingFeesDiff", headerName: "Kargo Ücretleri" },
      { field: "productTotalSum", headerName: "Toplam Ürün Tutarı CH" },
      { field: "productCustomCost", headerName: "Ürün Custom Maliyeti CH" },
      { field: "returnAndExchange", headerName: "İade ve Değişim CH" },
      { field: "ShippingFeesCSV", headerName: "Kargo Gider CH" },
      { field: "expenses", headerName: "Diğer Giderler" },
    ];

    const Allshops = ["all", ...new Set(data.map((item) => item.SelectedShop))];
    console.log("Allshops:", data);
    const AllPersonel = [
      "all",
      ...new Set(data.map((item) => item.Responsible)),
    ];

    const filteredData = Array.from(
      new Map(
        data
          .filter((item) => {
            const itemDate = new Date(item.StartDate);
            const start = startDate ? new Date(startDate) : null;
            const end = endDate ? new Date(endDate) : null;

            const matchesShop =
              selectedShop === "all" || item.SelectedShop === selectedShop;
            const matchesPersonnel =
              selectedUser === "all" || item.Responsible === selectedUser;
            const matchesDate =
              (!start || itemDate >= start) && (!end || itemDate <= end);

            return matchesShop && matchesPersonnel && matchesDate; // Added personnel filter
          })
          .map((item) => [item.ID, { ...item }])
      ).values()
    ).map((item) => ({
      ...item,
      ...calculateMetrics(item, startDate, endDate, userEarnings),
    }));

    let uniqueShopResponsibles = [];
    if (selectedUser !== "all" || selectedShop !== "all") {
      uniqueShopResponsibles = [
        ...new Set(
          filteredData
            .filter((item) => item.Responsible)
            .map((item) => item.Responsible)
        ),
      ];
    }

    const totalExpenses = filteredData.reduce(
      (sum, item) => sum + Math.abs(item.expenses),
      0
    );

    const totalSum = filteredData.reduce(
      (sum, item) => sum + Math.abs(item.totalSalesAmount),
      0
    );

    const shippingFeesCustomHub = filteredData.reduce(
      (sum, item) => sum + Math.abs(item.ShippingFeesCSV),
      0
    );
    const productCustomCost = filteredData.reduce(
      (sum, item) => sum + Math.abs(item.productCustomCost),
      0
    );
    const totelFees = filteredData.reduce(
      (sum, item) => sum + Math.abs(item.totalFees),
      0
    );
    const totalMarketing = filteredData.reduce(
      (sum, item) => sum + Math.abs(item.totalMarketingFees),
      0
    );
    const totalTPCExpenses = formatCurrency(
      filteredData.reduce((sum, item) => sum + Math.abs(item.tpcExpenses), 0)
    );
    const etsyRealDeposit = filteredData.reduce(
      (sum, item) => sum + Math.abs(item.PaymentFee),
      0
    );

    const totalSalesSummary = filteredData.reduce(
      (sum, item) => sum + Math.abs(item.salesSummaryDiff),
      0
    );

    const totalRefundAmount = filteredData
      .reduce((sum, item) => sum + item.totalRefundAmount, 0)
      .toFixed(0);

    const totalSalesAmount = filteredData.reduce(
      (sum, item) => sum + item.totalSalesAmount,
      0
    );

    const totalPersonelExpenses = filteredData.reduce(
      (sum, item) => sum + item.selectedEarnings,
      0
    );

    const totalMarketingPercentage =
      parseFloat((totalMarketing / totalSalesSummary).toFixed(4)) * 100;
    const totalFeePercentage =
      parseFloat((totelFees / totalSalesSummary).toFixed(4)) * 100;
    const totalShippingPercentage =
      parseFloat((shippingFeesCustomHub / totalSalesSummary).toFixed(4)) * 100;
    const totalExpensesPercentage =
      parseFloat((totalExpenses / totalSalesSummary).toFixed(4)) * 100;
    const totalReturnPercentage =
      parseFloat((totalRefundAmount / totalSalesAmount).toFixed(4)) * 100;

    const totalProfitSum = filteredData.reduce((sum, item) => {
      const profit = Number(item.totalProfit);
      return !isNaN(profit) ? sum + profit : sum;
    }, 0);

    const totalReelProfitSum = filteredData.reduce((sum, item) => {
      const profit = Number(item.reelTotalProfit);
      return !isNaN(profit) ? sum + profit : sum;
    }, 0);

    const totalProfitViaUnit = totalProfitSum / totalSum;
    const totalReelProfitViaUnit = totalReelProfitSum / totalSum;
    const totalMarketingViaUnit = totalMarketing / totalSum;
    const totalFeeViaUnit = totelFees / totalSum;
    const shippingFeeViaUnit = shippingFeesCustomHub / totalSum;
    const expenesViaUnit = totalExpenses / totalSum;

    let uniqueShops = [];
    if (selectedUser !== "all" || selectedShop !== "all") {
      uniqueShops = [...new Set(filteredData.map((item) => item.SelectedShop))];
    }

    const columns = [
      { field: "ID", headerName: "ID", width: 50, backgroundColor: "#5CB338" },
      { field: "Responsible", headerName: "Kullanıcı Adı", width: 70 },
      { field: "SelectedShop", headerName: "Mağaza", width: 130 },
      { field: "StartDateFormat", headerName: "Başlangıç Tarihi", width: 130 },
      {
        field: "EndDateFormat",
        headerName: "Bitiş Tarihi",
        width: 130,
      },
      {
        field: "totalProfit",
        headerName: "Kar/Zarar",
        width: 130,
        renderCell: (params) => {
          const value = parseFloat(params.value) || 0;
          const bgColor = value < 0 ? "#D84040" : "#5CB338"; // Negatifse kırmızı, pozitifse yeşil

          return (
            <Box
              sx={{
                backgroundColor: bgColor,
                color: "white",
                p: 1,
                borderRadius: 1,
                textAlign: "center",
                width: "100%",
              }}
            >
              {params.value}
            </Box>
          );
        },
      },
      {
        field: "reelTotalProfit",
        headerName: "Reel Kar/Zarar",
        width: 130,
        renderCell: (params) => {
          const value = parseFloat(params.value) || 0;
          const bgColor = value < 0 ? "#D84040" : "#5CB338"; // Negatifse kırmızı, pozitifse yeşil

          return (
            <Box
              sx={{
                backgroundColor: bgColor,
                color: "white",
                p: 1,
                borderRadius: 1,
                textAlign: "center",
                width: "100%",
              }}
            >
              {params.value}
            </Box>
          );
        },
      },
      { field: "PaymentFee", headerName: "Etsy Yatan para", width: 130 },
      {
        field: "lineTotalProfitViaUnit",
        headerName: "Adet Başına Kar(%)",
        width: 130,
      },
      {
        field: "lineReelProfitViaUnit",
        headerName: "Adet Başına Reel Kar(%)",
        width: 130,
      },
      {
        field: "CSVSalesSummary",
        headerName: "Toplam Satış Adedi",
        width: 160,
      },
      {
        field: "totalRefundsAmountsDiff",
        headerName: "Haftalik İadeler",
        width: 130,
      },
      { field: "ShippingFeesCSV", headerName: "Kargo Gider CH", width: 130 },
      {
        field: "lineShippingFeeViaUnit",
        headerName: "Adet Başına Kargo(%)",
        width: 130,
      },
      {
        field: "productTotalSum",
        headerName: "Toplam Ürün Tutarı CH",
        width: 150,
      },
      { field: "expenses", headerName: "Diğer Giderler", width: 130 },
      {
        field: "lineExpenesViaUnit",
        headerName: "Adet Başına Diğer Gider(%)",
        width: 130,
      },
      {
        field: "selectedEarnings",
        headerName: "Personel Giderleri",
        width: 130,
      },
      {
        field: "etsyMoneyDeposit",
        headerName: "Etsy Yatması Beklenen Para",
        width: 130,
      },
      { field: "totalSales", headerName: "Toplam Satış", width: 130 },
      {
        field: "listingFeesABS",
        headerName: "Liste Ücretleri Girilen",
        width: 130,
      },
      {
        field: "listingFeesDiff",
        headerName: "Liste Ücretleri Haftalık",
        width: 130,
      },
      {
        field: "lineTotalFeeViaUnit",
        headerName: "Adet Başına Liste Ücret(%)",
        width: 130,
      },
      {
        field: "marketingFeesABS",
        headerName: "Pazarlama Ücretleri Girilen",
        width: 130,
      },
      {
        field: "marketingFeesDiff",
        headerName: "Pazarlama Ücretleri Haftalık",
        width: 130,
      },
      {
        field: "lineTotalMarketingViaUnit",
        headerName: "Adet Başına Pazarlama(%)",
        width: 130,
      },
      {
        field: "ShippingFeesABS",
        headerName: "Kargo Ücretleri Girilen",
        width: 130,
      },

      {
        field: "ShippingFeesDiff",
        headerName: "Kargo Ücretleri Haftalık",
        width: 130,
      },

      {
        field: "salesSummary",
        headerName: "Sales Summary Girilen",
        width: 130,
      },
      {
        field: "salesSummaryDiff",
        headerName: "Sales Summary Haftalık",
        width: 130,
      },

      {
        field: "productCustomCost",
        headerName: "Ürün Custom Maliyeti CH",
        width: 160,
      },
      {
        field: "returnAndExchange",
        headerName: "İade ve Değişim CH",
        width: 160,
      },
      { field: "piaceInput", headerName: "Adet Girişi", width: 130 },
      { field: "Username", headerName: "Veriyi Giren Peronel", width: 130 },
    ];
    const COLORS = ["#1976d2", "#2e7d32", "#ed6c02", "#9c27b0", "#e91e63"];

    const MetricCard = ({ title, value }) => {
      let titleColor;
      if (
        title === "Toplam Brüt Kar/Zarar" ||
        title === "Adet Başına Kar/Zarar" ||
        title === "Toplam Reel Kar/Zarar" ||
        title === "Adet Başına Reel Kar/Zarar"
      )
        titleColor = "#5CB338";
      else if (
        title === "Adet Başına Kargo" ||
        title === "Adet Başına Diğer Gider Masrafları" ||
        title === "Adet Başına Fees" ||
        title === "Adet Başına Marketing"
      )
        titleColor = "#7695FF";
      else titleColor = "#FADFA1";

      const numericValue =
        typeof value === "string"
          ? parseFloat(value.replace(/[^0-9.-]/g, ""))
          : parseFloat(value) || 0;

      if (
        (title === "Toplam Brüt Kar/Zarar" ||
          title === "Adet Başına Kar/Zarar" ||
          title === "Toplam Reel Kar/Zarar" ||
          title === "Adet Başına Reel Kar/Zarar") &&
        numericValue < 0
      ) {
        titleColor = "#D84040";
      }

      return (
        <Card>
          <CardContent style={{ backgroundColor: titleColor }}>
            <Typography variant="h6">{title}</Typography>
            <Typography variant="h4">{value}</Typography>
          </CardContent>
        </Card>
      );
    };

    function toEnglishFormattedString(input) {
      if (input == null) return null;
      input = String(input).trim();

      let clean = input.replace(/\s/g, "").replace(/[^\d.,-]/g, "");

      if (clean.includes(",") && clean.includes(".")) {
        let lastComma = clean.lastIndexOf(",");
        let lastDot = clean.lastIndexOf(".");
        if (lastDot > lastComma) {
          clean = clean.replace(/,/g, "");
        } else {
          clean = clean.replace(/\./g, "").replace(",", ".");
        }
      } else if (clean.includes(",") && !clean.includes(".")) {
        clean = clean.replace(",", ".");
      }

      let number = parseFloat(clean);
      if (isNaN(number)) return null;
      number = Math.abs(number);
      return number;
    }

    const exportToExcel = () => {
      const headers = columns.map((col) => col.headerName);

      const numericFields = [
        "totalProfit",
        "PaymentFee",
        "CSVSalesSummary",
        "ShippingFeesCSV",
        "productTotalSum",
        "expenses",
        "selectedEarnings",
        "etsyMoneyDeposit",
        "totalSales",
        "listingFeesABS",
        "listingFeesDiff",
        "marketingFeesABS",
        "marketingFeesDiff",
        "ShippingFeesABS",
        "ShippingFeesDiff",
        "salesSummary",
        "salesSummaryDiff",
        "productCustomCost",
        "returnAndExchange",
        "totalTPCExpenses",
      ];

      const excelData = filteredData.map((row) =>
        columns.reduce((acc, col) => {
          let value = row[col.field];

          if (numericFields.includes(col.field)) {
            if (col.field === "totalProfit") {
              value = parseFloat(value) || 0;
            } else {
              value = toEnglishFormattedString(String(value));
            }
          }

          acc[col.headerName] = value;
          return acc;
        }, {})
      );

      const worksheet = XLSX.utils.json_to_sheet(excelData, {
        header: headers,
      });

      const range = XLSX.utils.decode_range(worksheet["!ref"]);

      columns.forEach((col, colIndex) => {
        if (numericFields.includes(col.field)) {
          for (
            let rowIndex = range.s.r + 1;
            rowIndex <= range.e.r;
            ++rowIndex
          ) {
            const cellAddress = XLSX.utils.encode_cell({
              r: rowIndex,
              c: colIndex,
            });
            const cell = worksheet[cellAddress];
            if (cell && typeof cell.v === "number") {
              cell.t = "n"; // türü number yap
              cell.z = "#,##0.00"; // format: 2 ondalıklı sayı
            }
          }
        }
      });

      const summaryData = [
        [
          "ETSY Toplam Satış Miktarı (Adet)",
          parseInt(
            String(totalSalesAmount).replace(/\./g, "").replace(",", ""),
            10
          ),
        ],
        [
          "ETSY Toplam İade Miktarı (Adet)",
          parseInt(
            String(totalRefundAmount).replace(/\./g, "").replace(",", ""),
            10
          ),
        ],
        [
          "ETSY Toplam İade Miktarı (Adet) %",
          `${totalReturnPercentage.toFixed(2)} %`,
        ],
        [],
        ["Net Satış", toEnglishFormattedString(totalSalesSummary)],
        ["ETSY Masrafları", toEnglishFormattedString(totelFees)],
        ["Reklam Giderleri", toEnglishFormattedString(totalMarketing)],
        [],
        ["Etsy Yatan Para", toEnglishFormattedString(etsyRealDeposit)],
        ["TPC Giderleri", toEnglishFormattedString(totalTPCExpenses)],
        ["Kargo Giderleri", toEnglishFormattedString(shippingFeesCustomHub)],
        ["Diğer Giderler", toEnglishFormattedString(totalExpenses)],
        [],
        ["Toplam Brüt Kar/Zarar", toEnglishFormattedString(totalProfitSum)],
        [],
        ["Adet Başına Kar/Zarar", totalProfitViaUnit.toFixed(2)],
        ["Adet Başına Marketing", totalMarketingViaUnit.toFixed(2)],
        ["Adet Başına Fees", totalFeeViaUnit.toFixed(2)],
        ["Adet Başına Diğer Gider Masrafları", expenesViaUnit.toFixed(2)],
        ["Adet Başına Kargo", shippingFeeViaUnit.toFixed(2)],
        [],
        ["Adet Başına Marketing %", `${totalMarketingPercentage.toFixed(2)} %`],
        ["Adet Başına Fees %", `${totalFeePercentage.toFixed(2)} %`],
        ["Adet Başına Kargo %", `${totalShippingPercentage.toFixed(2)} %`],
        [
          "Adet Başına Diğer Gider Masrafları %",
          `${totalExpensesPercentage.toFixed(2)} %`,
        ],
      ];

      const summarySheet = XLSX.utils.aoa_to_sheet(summaryData);

      const summaryRange = XLSX.utils.decode_range(summarySheet["!ref"]);
      for (let R = summaryRange.s.r; R <= summaryRange.e.r; ++R) {
        const cellAddress = { c: 1, r: R }; // B sütunu
        const cellRef = XLSX.utils.encode_cell(cellAddress);
        const cell = summarySheet[cellRef];

        if (!cell) continue;

        if (R === 0 || R === 1) {
          if (typeof cell.v === "number") {
            cell.z = "#,##0";
            cell.t = "n";
          }
        } else if (typeof cell.v === "number") {
          cell.z = "#,##0.00";
          cell.t = "n";
        }
        // Yüzde değerleri için yüzde formatı uygula
        else if (typeof cell.v === "string" && cell.v.includes("%")) {
          const number = parseFloat(cell.v.replace("%", "").trim());
          if (!isNaN(number)) {
            cell.v = number / 100;
            cell.t = "n";
            cell.z = "0.00%";
          }
        }
      }

      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Veriler");
      XLSX.utils.book_append_sheet(workbook, summarySheet, "Özet");

      const excelBuffer = XLSX.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });

      const data = new Blob([excelBuffer], {
        type: "application/octet-stream",
      });
      saveAs(data, "exported_data.xlsx");
    };

    const exportShopFees = async () => {
      try {
        const response = await axios.post(path + "/api/GetShopFees", {
          UserID: user?.ID,
        });
        const shopFees = response.data;

        const headers = [
          "SelectedShop",
          "StartDate",
          "EndDate",
          "PaymentDate",
          "PaymentFee",
        ];

        const excelData = shopFees.map((row) => ({
          SelectedShop: row.SelectedShop,
          StartDate: row.StartDate,
          EndDate: row.EndDate,
          PaymentDate: row.PaymentDate,
          PaymentFee: row.PaymentFee,
        }));

        const worksheet = XLSX.utils.json_to_sheet(excelData, {
          header: headers,
        });
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "ShopFees");

        const excelBuffer = XLSX.write(workbook, {
          bookType: "xlsx",
          type: "array",
        });
        const data = new Blob([excelBuffer], {
          type: "application/octet-stream",
        });
        saveAs(data, "shop_fees.xlsx");
      } catch (error) {
        console.error("Error fetching shop fees:", error);
      }
    };

    const handleShopChange = (event) => {
      setSelectedShop(event.target.value);
      setSelectedUser("all"); // Mağaza değiştiğinde personeli sıfırla
    };

    // Personel seçildiğinde mağazayı "all" yapacak handler
    const handleUserChange = (event) => {
      setSelectedUser(event.target.value);
      setSelectedShop("all");
    };

    const [currentShopIndex, setCurrentShopIndex] = useState(
      Allshops.indexOf(selectedShop) || 0
    );

    useEffect(() => {
      setCurrentShopIndex(Allshops.indexOf(selectedShop));
    }, [selectedShop]);

    const handleNextShop = () => {
      if (currentShopIndex < Allshops.length - 1) {
        const nextShop = Allshops[currentShopIndex + 1];
        setSelectedShop(nextShop);
        setSelectedUser("all");
      }
    };

    const handlePreviousShop = () => {
      if (currentShopIndex > 0) {
        const prevShop = Allshops[currentShopIndex - 1];
        setSelectedShop(prevShop);
        setSelectedUser("all");
      }
    };

    const [currentPersonnelIndex, setCurrentPersonnelIndex] = useState(
      AllPersonel.indexOf(selectedUser) || 0
    );

    useEffect(() => {
      setCurrentPersonnelIndex(AllPersonel.indexOf(selectedUser));
    }, [selectedUser]);

    const handleNextPersonnel = () => {
      if (currentPersonnelIndex < AllPersonel.length - 1) {
        const nextPersonnel = AllPersonel[currentPersonnelIndex + 1];
        setSelectedUser(nextPersonnel);
        setSelectedShop("all");
      }
    };

    const handlePreviousPersonnel = () => {
      if (currentPersonnelIndex > 0) {
        const prevPersonnel = AllPersonel[currentPersonnelIndex - 1];
        setSelectedUser(prevPersonnel);
        setSelectedShop("all");
      }
    };

    return (
      <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={tr}>
        <Box sx={{ p: { xs: 1, sm: 2, md: 3 } }}>
          <Container maxWidth="xl">
            <Grid container spacing={3}>
              {/* Filters */}
              <Grid item xs={12}>
                <Card>
                  <CardContent>
                    <Grid container spacing={3}>
                      {/* İlk Satır: Mağaza ve Personel Seçimleri */}
                      <Grid
                        item
                        xs={12}
                        md={5}
                        container
                        alignItems="center"
                        spacing={1}
                      >
                        <Grid item xs={10}>
                          <FormControl fullWidth>
                            <InputLabel>Mağaza Seç</InputLabel>
                            <Select
                              value={selectedShop}
                              label="Mağaza Seç"
                              onChange={handleShopChange}
                            >
                              {Allshops.map((shop) => (
                                <MenuItem key={shop} value={shop}>
                                  {shop === "all" ? "Tüm Mağazalar" : shop}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </Grid>
                        <Grid item xs={2}>
                          <ButtonGroup variant="outlined" size="small">
                            <Button
                              onClick={handlePreviousShop}
                              disabled={currentShopIndex <= 0}
                            >
                              <ArrowBackIcon fontSize="small" />
                            </Button>
                            <Button
                              onClick={handleNextShop}
                              disabled={currentShopIndex >= Allshops.length - 1}
                            >
                              <ArrowForwardIcon fontSize="small" />
                            </Button>
                          </ButtonGroup>
                        </Grid>
                      </Grid>

                      <Grid
                        item
                        xs={12}
                        md={5}
                        container
                        alignItems="center"
                        spacing={1}
                      >
                        <Grid item xs={10}>
                          <FormControl fullWidth>
                            <InputLabel>Personel Seç</InputLabel>
                            <Select
                              value={selectedUser}
                              label="Personel Seç"
                              onChange={handleUserChange}
                            >
                              {AllPersonel.map((personnel) => (
                                <MenuItem key={personnel} value={personnel}>
                                  {personnel === "all"
                                    ? "Tüm Personel"
                                    : personnel}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </Grid>
                        <Grid item xs={2}>
                          <ButtonGroup variant="outlined" size="small">
                            <Button
                              onClick={handlePreviousPersonnel}
                              disabled={currentPersonnelIndex <= 0}
                            >
                              <ArrowBackIcon fontSize="small" />
                            </Button>
                            <Button
                              onClick={handleNextPersonnel}
                              disabled={
                                currentPersonnelIndex >= AllPersonel.length - 1
                              }
                            >
                              <ArrowForwardIcon fontSize="small" />
                            </Button>
                          </ButtonGroup>
                        </Grid>
                      </Grid>

                      {/* İkinci Satır: Tarih Seçimleri */}
                      <Grid item xs={12} md={10}>
                        <Grid container spacing={2}>
                          <Grid item xs={12} sm={6}>
                            <DatePicker
                              label="Başlangıç Tarihi"
                              value={startDate}
                              onChange={(newValue) => setStartDate(newValue)}
                              renderInput={(params) => (
                                <TextField {...params} fullWidth />
                              )}
                              format="dd/MM/yyyy"
                            />
                          </Grid>
                          <Grid item xs={12} sm={6}>
                            <DatePicker
                              label="Bitiş Tarihi"
                              value={endDate}
                              onChange={(newValue) => setEndDate(newValue)}
                              renderInput={(params) => (
                                <TextField {...params} fullWidth />
                              )}
                              format="dd/MM/yyyy"
                              minDate={startDate}
                            />
                          </Grid>

                          <Grid item xs={12} sm={2}>
                            <Button
                              variant="contained"
                              color="primary"
                              onClick={handleFetchData}
                              disabled={loading}
                              fullWidth
                            >
                              {loading
                                ? "Yükleniyor..."
                                : "Kullanıcı Verilerini Getir"}
                            </Button>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  </CardContent>
                </Card>
                {error && (
                  <Grid item xs={12}>
                    <p style={{ color: "red" }}>{error}</p>
                  </Grid>
                )}
              </Grid>

              {/* Summary Cards - First Row */}
              <Grid item xs={12} md={3} sx>
                <MetricCard
                  className="custom-card"
                  title="Toplam Brüt Kar/Zarar"
                  value={formatCurrency(totalProfitSum)}
                />
              </Grid>
              <Grid item xs={12} md={3} sx>
                <MetricCard
                  className="custom-card"
                  title="Toplam Reel Kar/Zarar"
                  value={formatCurrency(totalReelProfitSum)}
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <MetricCard
                  title="Etsy Yatan Para"
                  value={formatCurrency(etsyRealDeposit.toFixed(2))}
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <MetricCard
                  title="ETSY Toplam Satış Miktarı (Adet)"
                  value={totalSalesAmount}
                />
              </Grid>

              {/* Summary Cards - Second Row */}
              <Grid item xs={12} md={3}>
                <MetricCard
                  title="ETSY Toplam İade Miktarı (Adet)"
                  value={
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        width: "100%",
                      }}
                    >
                      <span>{totalRefundAmount}</span>
                      <span>{"%" + totalReturnPercentage.toFixed(2)}</span>
                    </div>
                  }
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <MetricCard
                  title="Net Satış"
                  value={
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        width: "100%",
                      }}
                    >
                      <span>
                        {formatCurrency(totalSalesSummary.toFixed(2))}
                      </span>
                    </div>
                  }
                />
              </Grid>

              <Grid item xs={12} md={3}>
                <MetricCard
                  title="Etsy Yatması Beklenen Para"
                  value={formatCurrency(
                    filteredData.reduce(
                      (sum, item) => sum + Number(item.etsyMoneyDeposit),
                      0
                    )
                  )}
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <MetricCard
                  title="Reklam Giderleri"
                  value={formatCurrency(
                    filteredData.reduce(
                      (sum, item) => sum + Math.abs(item.totalMarketingFees),
                      0
                    )
                  )}
                />
              </Grid>

              <Grid item xs={12} md={3}>
                <MetricCard
                  title="Adet Başına Kar/Zarar"
                  value={"$" + totalProfitViaUnit.toFixed(2)}
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <MetricCard
                  title="Adet Başına Reel Kar/Zarar"
                  value={"$" + totalReelProfitViaUnit.toFixed(2)}
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <MetricCard
                  title="ETSY Masrafları"
                  value={formatCurrency(
                    filteredData.reduce(
                      (sum, item) => sum + Math.abs(item.totalFees),
                      0
                    )
                  )}
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <MetricCard
                  title="TPC Giderleri"
                  value={formatCurrency(
                    filteredData.reduce(
                      (sum, item) => sum + Math.abs(item.tpcExpenses),
                      0
                    )
                  )}
                />
              </Grid>

              <Grid item xs={12} md={3}>
                <MetricCard
                  title="Kargo Giderleri"
                  value={formatCurrency(shippingFeesCustomHub.toFixed(2))}
                />
              </Grid>

              {/* Unit Metrics */}
              <Grid item xs={12} md={3}>
                <MetricCard
                  title="Diğer Giderler"
                  value={formatCurrency(totalExpenses.toFixed(2))}
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <MetricCard
                  title="Adet Başına Marketing"
                  value={
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        width: "100%",
                      }}
                    >
                      <span>{"$" + totalMarketingViaUnit.toFixed(2)}</span>
                      <span>{"%" + totalMarketingPercentage.toFixed(2)}</span>
                    </div>
                  }
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <MetricCard
                  title="Adet Başına Fees"
                  value={
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        width: "100%",
                      }}
                    >
                      <span>{"$" + totalFeeViaUnit.toFixed(2)}</span>
                      <span>{"%" + totalFeePercentage.toFixed(2)}</span>
                    </div>
                  }
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <MetricCard
                  title="Adet Başına Kargo"
                  value={
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        width: "100%",
                      }}
                    >
                      <span>{"$" + shippingFeeViaUnit.toFixed(2)}</span>
                      <span>{"%" + totalShippingPercentage.toFixed(2)}</span>
                    </div>
                  }
                />
              </Grid>

              <Grid item xs={12} md={3}>
                <MetricCard
                  title="Adet Başına Diğer Gider Masrafları"
                  value={
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        width: "100%",
                      }}
                    >
                      <span>{"$" + expenesViaUnit.toFixed(2)}</span>
                      <span>{"%" + totalExpensesPercentage.toFixed(2)}</span>
                    </div>
                  }
                />
              </Grid>

              <Grid item xs={12} md={12}>
                <Card sx={{ mb: 0 }}>
                  <CardContent>
                    <Typography variant="h6" color="primary">
                      Mağaza Personeli: {uniqueShopResponsibles}
                    </Typography>

                    <Typography variant="h6" color="primary">
                      Personel Sorumlu Mağazalar: {uniqueShops.join(", ")}
                    </Typography>

                    <Typography variant="h6" color="secondary">
                      Toplam Çalışma Süresi: {totalWorkHours} saat
                    </Typography>

                    {(user.Admin === 1 || user.Username === selectedUser) && (
                      <Typography variant="h6" color="secondary">
                        Toplam Maliyet: {totalCalculations.totalCost} USD
                        <Typography
                          component="span"
                          sx={{
                            color: "warning.main", // sarı renk
                            fontSize: "0.8em", // ana yazıdan daha küçük
                            marginLeft: 1, // sol boşluk
                          }}
                        >
                          (ARGE: {totalCalculations.argeCost} USD, Diğer:{" "}
                          {totalCalculations.otherCost} USD)
                        </Typography>
                      </Typography>
                    )}
                  </CardContent>
                </Card>
              </Grid>

              {/* Charts */}
              <Grid item xs={12}>
                <Card>
                  <CardContent>
                    <Grid container spacing={2}>
                      <Grid item xs={12} md={3}>
                        <FormControl fullWidth>
                          <InputLabel>Gösterilecek Veri</InputLabel>
                          <Select
                            multiple
                            value={selectedMetrics}
                            label="Gösterilecek Veriler"
                            onChange={handleSelectedMetricsChange}
                          >
                            {metricOptions.map((option) => (
                              <MenuItem key={option.field} value={option.field}>
                                {option.headerName}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </Grid>
                    </Grid>
                  </CardContent>
                </Card>
              </Grid>

              {/* Dynamic Bar Chart */}
              <Grid item xs={12}>
                <Card>
                  <CardContent>
                    <Typography variant="h6" gutterBottom>
                      Veri Karşılaştırma Grafiği
                    </Typography>
                    <Box sx={{ height: 400 }}>
                      <ResponsiveContainer>
                        <LineChart
                          data={filteredData
                            .sort(
                              (a, b) =>
                                new Date(a.StartDate) - new Date(b.StartDate)
                            )
                            .map((item) => ({
                              ...item,
                              ...selectedMetrics.reduce(
                                (acc, metric) => ({
                                  ...acc,
                                  [metric]: Number(item[metric]) || 0,
                                }),
                                {}
                              ),
                            }))}
                          margin={{ top: 20, right: 30, left: 40, bottom: 5 }}
                        >
                          <CartesianGrid strokeDasharray="3 3" />
                          <XAxis
                            dataKey="StartDate"
                            tickFormatter={(date) =>
                              new Date(date).toLocaleDateString("tr-TR")
                            }
                            interval="preserveStartEnd"
                          />
                          <YAxis />
                          <Tooltip
                            formatter={(value, name, props) => {
                              if (typeof value === "number") {
                                return name.includes("Fee") ||
                                  name.includes("Price") ||
                                  name.includes("Cost") ||
                                  name.includes("Profit")
                                  ? formatCurrency(value)
                                  : value.toLocaleString();
                              }
                              return value;
                            }}
                            labelFormatter={(label) =>
                              new Date(label).toLocaleDateString("tr-TR")
                            }
                          />
                          <Legend />
                          {selectedMetrics.map((metric, index) => {
                            const metricOption = metricOptions.find(
                              (option) => option.field === metric
                            );
                            return (
                              <Line
                                key={metric}
                                type="linear"
                                dataKey={metric}
                                name={metricOption?.headerName}
                                stroke={COLORS[index % COLORS.length]} // Renk döngüsü için modulo kullanımı
                                strokeWidth={2}
                                dot={{ r: 4, strokeWidth: 1, fill: "#fff" }}
                                activeDot={{ r: 6, strokeWidth: 1 }}
                              />
                            );
                          })}
                        </LineChart>
                      </ResponsiveContainer>
                    </Box>
                  </CardContent>
                </Card>
              </Grid>

              <Grid item xs={12} md={6}>
                <Card>
                  <CardContent>
                    <Typography variant="h6" gutterBottom>
                      Günlük Efor Dağılımı
                    </Typography>
                    <Box sx={{ height: 300 }}>
                      <ResponsiveContainer width="100%" height="100%">
                        <LineChart data={dailyEfforts}>
                          <CartesianGrid strokeDasharray="3 3" />
                          <XAxis dataKey="date" />
                          <YAxis />
                          <Tooltip />
                          <Legend />
                          <Line
                            type="monotone"
                            dataKey="hours"
                            stroke="#1976d2"
                            name="Saat"
                          />
                        </LineChart>
                      </ResponsiveContainer>
                    </Box>
                  </CardContent>
                </Card>
              </Grid>

              <Grid item xs={12} md={6}>
                <Card>
                  <CardContent>
                    <Typography variant="h6" gutterBottom>
                      Görev Dağılımı
                    </Typography>
                    <Box sx={{ height: 300 }}>
                      <ResponsiveContainer width="100%" height="100%">
                        <PieChart>
                          <Pie
                            data={taskDistribution}
                            dataKey="value"
                            nameKey="name"
                            cx="50%"
                            cy="50%"
                            outerRadius={100}
                            label
                          >
                            {/* Her dilim için farklı renk vermek */}
                            {taskDistribution.map((entry, index) => (
                              <Cell
                                key={`cell-${index}`}
                                fill={COLORS[index % COLORS.length]}
                              />
                            ))}
                          </Pie>
                          <Tooltip />
                        </PieChart>
                      </ResponsiveContainer>
                    </Box>
                  </CardContent>
                </Card>
              </Grid>

              {/* Data Table */}
              <Grid item xs={12}>
                <Card>
                  <CardContent>
                    <Typography variant="h6" gutterBottom>
                      Detaylı Veri
                    </Typography>
                    <Box sx={{ height: 400 }}>
                      <DataGrid
                        rows={filteredData}
                        getRowId={(row) => row.ID}
                        columns={columns}
                        pageSize={10}
                        rowsPerPageOptions={[10, 25, 50]}
                        components={{
                          Toolbar: GridToolbar,
                        }}
                        disableSelectionOnClick
                      />
                    </Box>
                  </CardContent>
                </Card>
                <Box
                  sx={{
                    display: "flex",
                    gap: 2,
                    justifyContent: "center",
                    mb: 2,
                  }}
                >
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={exportToExcel}
                  >
                    Excel'e Aktar
                  </Button>
                  {user.Admin === 1 || user.Username === "osman kale" ? (
                    <Button
                      variant="contained"
                      color="secondary"
                      onClick={exportShopFees}
                    >
                      Etsy Yatan Para Excele Aktar
                    </Button>
                  ) : null}
                </Box>
              </Grid>
            </Grid>
          </Container>
        </Box>
      </LocalizationProvider>
    );
  };

  const CHART_COLORS = [
    "#1976d2",
    "#2e7d32",
    "#ed6c02",
    "#9c27b0",
    "#e91e63",
    "#f44336",
    "#ff9800",
    "#3f51b5",
  ];
  const SHOP_COLORS = [
    "#FF6B6B",
    "#4ECDC4",
    "#45B7D1",
    "#96CEB4",
    "#FECA57",
    "#FF9FF3",
    "#54A0FF",
    "#48DBFB",
    "#A29BFE",
    "#FD79A8",
  ];

  const metricOptions = [
    {
      field: "totalProfit",
      headerName: "Kar/Zarar",
      format: "currency",
      icon: <TrendingUpIcon />,
    },
    {
      field: "etsyRealDeposit",
      headerName: "Etsy Yatan Para",
      format: "currency",
      icon: <AnalyticsIcon />,
    },
    {
      field: "etsyMoneyDeposit",
      headerName: "Etsy Yatması Beklenen Para",
      format: "currency",
      icon: <AssessmentIcon />,
    },
    {
      field: "totalSalesAmount",
      headerName: "Toplam Satış Miktarı",
      format: "number",
      icon: <BarChartIcon />,
    },
    {
      field: "totalRefundAmount",
      headerName: "İadeler",
      format: "number",
      icon: <ShowChartIcon />,
    },
    {
      field: "totalMarketingFees",
      headerName: "Pazarlama Ücretleri",
      format: "currency",
      icon: <BubbleChartIcon />,
    },
    {
      field: "totalFees",
      headerName: "Liste Ücretleri",
      format: "currency",
      icon: <PieChartIcon />,
    },
    {
      field: "shippingExpenses",
      headerName: "Kargo Ücretleri",
      format: "currency",
      icon: <TimelineIcon />,
    },
    {
      field: "tpcExpenses",
      headerName: "TPC Giderleri",
      format: "currency",
      icon: <AnalyticsIcon />,
    },
    {
      field: "expenses",
      headerName: "Diğer Giderler",
      format: "currency",
      icon: <AssessmentIcon />,
    },
  ];

const CompareShops = () => {
  const [shopSelections, setShopSelections] = useState([]);
  const [selectedShopRows, setSelectedShopRows] = useState([]);
  const [selectedMetric, setSelectedMetric] = useState("totalProfit");
  const [chartType, setChartType] = useState("bar");
  const [comparisonReady, setComparisonReady] = useState(false);
  const [sortConfig, setSortConfig] = useState({ field: null, direction: 'asc' });
  const [viewMode, setViewMode] = useState('cards');
  const [nextRowId, setNextRowId] = useState(1);
  const [aggregationMode, setAggregationMode] = useState('sum'); // 'sum' veya 'weekly'

  // Get unique shop names from data
  const allShops = [...new Set(data.map((item) => item.SelectedShop))]
    .filter(Boolean)
    .sort();

  const metricOptions = [
    { field: "totalProfit", headerName: "Kar/Zarar", format: "currency", icon: "", category: "profit", lowerIsBetter: false },
    { field: "reelTotalProfit", headerName: "Gerçek Kar", format: "currency", icon: "", category: "profit", lowerIsBetter: false },
    { field: "etsyRealDeposit", headerName: "Etsy Yatan Para", format: "currency", icon: "", category: "revenue", lowerIsBetter: false },
    { field: "etsyMoneyDeposit", headerName: "Etsy Yatması Beklenen", format: "currency", icon: "", category: "revenue", lowerIsBetter: false },
    { field: "totalSalesAmount", headerName: "Toplam Satış Miktarı", format: "number", icon: "", category: "revenue", lowerIsBetter: false },
    { field: "totalRefundAmount", headerName: "İadeler", format: "number", icon: "↩", category: "costs", lowerIsBetter: true },
    { field: "totalMarketingFees", headerName: "Pazarlama Ücretleri", format: "currency", icon: "", category: "costs", lowerIsBetter: true },
    { field: "totalFees", headerName: "Liste Ücretleri", format: "currency", icon: "", category: "costs", lowerIsBetter: true },
    { field: "shippingExpenses", headerName: "Kargo Ücretleri", format: "currency", icon: "", category: "costs", lowerIsBetter: true },
    { field: "tpcExpenses", headerName: "TPC Giderleri", format: "currency", icon: "", category: "costs", lowerIsBetter: true },
    { field: "expenses", headerName: "Diğer Giderler", format: "currency", icon: "", category: "costs", lowerIsBetter: true },
    { field: "profitPerUnit", headerName: "Adet Başına Kar", format: "currency", icon: "", category: "perUnit", lowerIsBetter: false },
    { field: "reelProfitPerUnit", headerName: "Adet Başına Reel Kar", format: "currency", icon: "", category: "perUnit", lowerIsBetter: false },
    { field: "marketingPerUnit", headerName: "Adet Başına Pazarlama", format: "currency", icon: "", category: "perUnit", lowerIsBetter: true },
    { field: "feesPerUnit", headerName: "Adet Başına Ücretler", format: "currency", icon: "", category: "perUnit", lowerIsBetter: true },
    { field: "shippingPerUnit", headerName: "Adet Başına Kargo", format: "currency", icon: "", category: "perUnit", lowerIsBetter: true },
    { field: "expensesPerUnit", headerName: "Adet Başına Giderler", format: "currency", icon: "", category: "perUnit", lowerIsBetter: true },
  ];

  // Quick preset configurations
  const presets = [
    { name: "Bu Ay", days: 30 },
    { name: "Son 3 Ay", days: 90 },
    { name: "Son 6 Ay", days: 180 },
    { name: "Bu Yıl", days: 365 },
  ];

  // Period comparison presets (for same shop)
  const periodPresets = [
    { 
      name: "Bu Ay vs Geçen Ay", 
      periods: [
        { name: "Bu Ay", days: 30, offset: 0 },
        { name: "Geçen Ay", days: 30, offset: 30 }
      ]
    },
    { 
      name: "Son 30 Gün vs Önceki 30 Gün", 
      periods: [
        { name: "Son 30 Gün", days: 30, offset: 0 },
        { name: "Önceki 30 Gün", days: 30, offset: 30 }
      ]
    },
    { 
      name: "Son 90 Gün vs Önceki 90 Gün", 
      periods: [
        { name: "Son 90 Gün", days: 90, offset: 0 },
        { name: "Önceki 90 Gün", days: 90, offset: 90 }
      ]
    },
  ];

  // Format functions
  const formatCurrency = (value) => {
    if (value === undefined || value === null) return "-";
    return Number(value).toLocaleString("en-US", {
      style: "currency",
      currency: "USD",
    });
  };

  const formatNumber = (value) => {
    if (value === undefined || value === null) return "-";
    return Number(value).toLocaleString();
  };

  const formatValue = (value, format) => {
    if (format === "currency") return formatCurrency(value);
    return formatNumber(value);
  };

  // Calculate percentage difference
  const calculateDifference = (value1, value2) => {
    if (!value1 || !value2) return null;
    const num1 = Number(value1);
    const num2 = Number(value2);
    if (isNaN(num1) || isNaN(num2) || num2 === 0) return null;
    const diff = ((num1 - num2) / Math.abs(num2)) * 100;
    return diff.toFixed(2);
  };

  // Get best/worst shop for a metric
  const getBestWorst = (metricField) => {
    if (shopSelections.length === 0) return { best: null, worst: null };
    
    const validSelections = shopSelections.filter(s => s.metrics !== null);
    if (validSelections.length === 0) return { best: null, worst: null };

    const metricInfo = metricOptions.find(m => m.field === metricField);
    const lowerIsBetter = metricInfo?.lowerIsBetter || false;

    const values = validSelections.map(s => ({
      shop: s.displayName,
      value: s.metrics[metricField],
      color: s.color
    }));

    const sorted = [...values].sort((a, b) => {
      if (lowerIsBetter) {
        return Number(a.value) - Number(b.value);
      } else {
        return Number(b.value) - Number(a.value);
      }
    });

    return { best: sorted[0], worst: sorted[sorted.length - 1] };
  };

  // Add a new shop row
  const addShopRow = () => {
    const newRow = {
      id: nextRowId,
      shop: allShops[0] || '',
      startDate: null,
      endDate: null,
      label: ''
    };
    setSelectedShopRows([...selectedShopRows, newRow]);
    setNextRowId(nextRowId + 1);
  };

  // Remove a shop row
  const removeShopRow = (id) => {
    setSelectedShopRows(selectedShopRows.filter(row => row.id !== id));
  };

  // Update shop row
  const updateShopRow = (id, field, value) => {
    setSelectedShopRows(selectedShopRows.map(row => 
      row.id === id ? { ...row, [field]: value } : row
    ));
  };

  // Apply preset to all rows
  const applyPresetToAll = (days) => {
    const end = new Date();
    const start = new Date();
    start.setDate(start.getDate() - days);
    
    setSelectedShopRows(selectedShopRows.map(row => ({
      ...row,
      startDate: start,
      endDate: end
    })));
  };

  // Apply period comparison preset
  const applyPeriodPreset = (preset, shopName) => {
    const newRows = preset.periods.map((period, index) => {
      let startDate, endDate;
      
      if (period.start && period.end) {
        startDate = period.start;
        endDate = period.end;
      } else {
        endDate = new Date();
        endDate.setDate(endDate.getDate() - period.offset);
        startDate = new Date(endDate);
        startDate.setDate(startDate.getDate() - period.days);
      }

      return {
        id: nextRowId + index,
        shop: shopName,
        startDate,
        endDate,
        label: period.name
      };
    });

    setSelectedShopRows([...selectedShopRows, ...newRows]);
    setNextRowId(nextRowId + preset.periods.length);
  };

  // Process shop data with weekly breakdown
  const processShopDataWeekly = (shop, startDate, endDate) => {
    if (!shop || !startDate || !endDate) return [];

    const shopData = data.filter((item) => {
      const itemShop = item.SelectedShop;
      const itemDate = new Date(item.StartDate);
      const start = new Date(startDate);
      const end = new Date(endDate);
      return itemShop === shop && itemDate >= start && itemDate <= end;
    });

    if (shopData.length === 0) return [];

    // Her satırı ayrı ayrı işle (haftalık veriler)
    return shopData.map((item) => {
      const itemStartDate = new Date(item.StartDate);
      const itemEndDate = new Date(item.EndDate);
      const processedItem = calculateMetrics(item, item.StartDate, item.EndDate);
      
      return {
        ...item,
        ...processedItem,
        weekLabel: `${itemStartDate.toLocaleDateString('tr-TR')} - ${itemEndDate.toLocaleDateString('tr-TR')}`,
        weekStart: itemStartDate,
        weekEnd: itemEndDate
      };
    });
  };

  // Process shop data (summarized)
  const processShopData = (shop, startDate, endDate) => {
    if (!shop || !startDate || !endDate) return null;

    const shopData = data.filter((item) => {
      const itemShop = item.SelectedShop;
      const itemDate = new Date(item.StartDate);
      const start = new Date(startDate);
      const end = new Date(endDate);
      return itemShop === shop && itemDate >= start && itemDate <= end;
    });

    if (shopData.length === 0) return null;

    const processedData = shopData.map((item) => ({
      ...item,
      ...calculateMetrics(item, startDate, endDate),
    }));

    return calculateSummaryMetrics(processedData);
  };

  // Calculate summary metrics
  const calculateSummaryMetrics = (shopData) => {
    if (!shopData || shopData.length === 0) return null;

    const metrics = {
      totalProfit: shopData.reduce((sum, item) => sum + Number(item.totalProfit || 0), 0),
      reelTotalProfit: shopData.reduce((sum, item) => sum + Number(item.reelTotalProfit || 0), 0),
      etsyRealDeposit: shopData.reduce((sum, item) => sum + Number(item.PaymentFee || 0), 0),
      etsyMoneyDeposit: shopData.reduce((sum, item) => sum + Number(item.etsyMoneyDeposit || 0), 0),
      totalSalesAmount: shopData.reduce((sum, item) => sum + Number(item.totalSalesAmount || 0), 0),
      totalRefundAmount: shopData.reduce((sum, item) => sum + Number(item.totalRefundAmount || 0), 0),
      totalMarketingFees: shopData.reduce((sum, item) => sum + Number(item.totalMarketingFees || 0), 0),
      totalFees: shopData.reduce((sum, item) => sum + Number(item.totalFees || 0), 0),
      shippingExpenses: shopData.reduce((sum, item) => sum + Number(item.ShippingFeesCSV || 0), 0),
      tpcExpenses: shopData.reduce((sum, item) => sum + Number(item.tpcExpenses || 0), 0),
      expenses: shopData.reduce((sum, item) => sum + Number(item.expenses || 0), 0),
    };

    const totalSum = metrics.totalSalesAmount;
    if (totalSum > 0) {
      metrics.profitPerUnit = metrics.totalProfit / totalSum;
      metrics.reelProfitPerUnit = metrics.reelTotalProfit / totalSum;
      metrics.marketingPerUnit = metrics.totalMarketingFees / totalSum;
      metrics.feesPerUnit = metrics.totalFees / totalSum;
      metrics.shippingPerUnit = metrics.shippingExpenses / totalSum;
      metrics.expensesPerUnit = metrics.expenses / totalSum;
    } else {
      metrics.profitPerUnit = 0;
      metrics.reelProfitPerUnit = 0;
      metrics.marketingPerUnit = 0;
      metrics.feesPerUnit = 0;
      metrics.shippingPerUnit = 0;
      metrics.expensesPerUnit = 0;
    }

    return metrics;
  };

  // Calculate metrics for a single row
  const calculateRowMetrics = (item) => {
    const metrics = {
      totalProfit: Number(item.totalProfit || 0),
      reelTotalProfit: Number(item.reelTotalProfit || 0),
      etsyRealDeposit: Number(item.PaymentFee || 0),
      etsyMoneyDeposit: Number(item.etsyMoneyDeposit || 0),
      totalSalesAmount: Number(item.totalSalesAmount || 0),
      totalRefundAmount: Number(item.totalRefundAmount || 0),
      totalMarketingFees: Number(item.totalMarketingFees || 0),
      totalFees: Number(item.totalFees || 0),
      shippingExpenses: Number(item.ShippingFeesCSV || 0),
      tpcExpenses: Number(item.tpcExpenses || 0),
      expenses: Number(item.expenses || 0),
    };

    const totalSum = metrics.totalSalesAmount;
    if (totalSum > 0) {
      metrics.profitPerUnit = metrics.totalProfit / totalSum;
      metrics.reelProfitPerUnit = metrics.reelTotalProfit / totalSum;
      metrics.marketingPerUnit = metrics.totalMarketingFees / totalSum;
      metrics.feesPerUnit = metrics.totalFees / totalSum;
      metrics.shippingPerUnit = metrics.shippingExpenses / totalSum;
      metrics.expensesPerUnit = metrics.expenses / totalSum;
    } else {
      metrics.profitPerUnit = 0;
      metrics.reelProfitPerUnit = 0;
      metrics.marketingPerUnit = 0;
      metrics.feesPerUnit = 0;
      metrics.shippingPerUnit = 0;
      metrics.expensesPerUnit = 0;
    }

    return metrics;
  };

  // Run comparison
  const runComparison = () => {
    if (selectedShopRows.length === 0) {
      alert("Lütfen en az bir mağaza satırı ekleyin!");
      return;
    }

    const missingDates = selectedShopRows.filter(row => !row.startDate || !row.endDate);
    if (missingDates.length > 0) {
      alert("Lütfen tüm satırlar için tarih aralığı seçin!");
      return;
    }

    if (aggregationMode === 'weekly') {
      // Haftalık detaylı görünüm
      const allWeeklyData = [];
      let colorIndex = 0;

      selectedShopRows.forEach((row) => {
        const weeklyData = processShopDataWeekly(row.shop, row.startDate, row.endDate);
        
        weeklyData.forEach((weekItem) => {
          const displayName = row.label 
            ? `${row.shop} (${row.label}) - ${weekItem.weekLabel}`
            : `${row.shop} - ${weekItem.weekLabel}`;

          allWeeklyData.push({
            id: `${row.id}-${weekItem.weekStart.getTime()}`,
            shop: row.shop,
            displayName,
            dateRange: { 
              startDate: weekItem.weekStart, 
              endDate: weekItem.weekEnd 
            },
            label: row.label,
            weekLabel: weekItem.weekLabel,
            metrics: calculateRowMetrics(weekItem),
            color: CHART_COLORS[colorIndex % CHART_COLORS.length],
            rowLabel: row.label || row.shop
          });
          colorIndex++;
        });
      });

      setShopSelections(allWeeklyData);
    } else {
      // Toplamlanmış görünüm
      const selections = selectedShopRows.map((row, index) => {
        const displayName = row.label 
          ? `${row.shop} (${row.label})`
          : `${row.shop} - ${row.startDate.toLocaleDateString('tr-TR')} / ${row.endDate.toLocaleDateString('tr-TR')}`;

        return {
          id: row.id,
          shop: row.shop,
          displayName,
          dateRange: { startDate: row.startDate, endDate: row.endDate },
          label: row.label,
          metrics: processShopData(row.shop, row.startDate, row.endDate),
          color: CHART_COLORS[index % CHART_COLORS.length],
        };
      });

      setShopSelections(selections);
    }

    setComparisonReady(true);
  };

  // Sort table data
  const handleSort = (field) => {
    const direction = sortConfig.field === field && sortConfig.direction === 'asc' ? 'desc' : 'asc';
    setSortConfig({ field, direction });
  };

  const getSortedMetrics = () => {
    if (!sortConfig.field) return metricOptions;
    
    return [...metricOptions].sort((a, b) => {
      const validSelections = shopSelections.filter(s => s.metrics !== null);
      if (validSelections.length === 0) return 0;
      
      const avgA = validSelections.reduce((sum, s) => sum + (Number(s.metrics[a.field]) || 0), 0) / validSelections.length;
      const avgB = validSelections.reduce((sum, s) => sum + (Number(s.metrics[b.field]) || 0), 0) / validSelections.length;
      
      return sortConfig.direction === 'asc' ? avgA - avgB : avgB - avgA;
    });
  };

  // Render metric cards view
  const renderMetricCards = () => {
    const validSelections = shopSelections.filter(s => s.metrics !== null);
    if (validSelections.length === 0) return null;

    const categories = {
      profit: metricOptions.filter(m => m.category === 'profit'),
      revenue: metricOptions.filter(m => m.category === 'revenue'),
      costs: metricOptions.filter(m => m.category === 'costs'),
      perUnit: metricOptions.filter(m => m.category === 'perUnit'),
    };

    return (
      <Box>
        {Object.entries(categories).map(([categoryName, categoryMetrics]) => (
          <Box key={categoryName} sx={{ mb: 4 }}>
            <Typography variant="h6" sx={{ mb: 2, textTransform: 'capitalize' }}>
              {categoryName === 'profit' && '💰 Karlılık'}
              {categoryName === 'revenue' && '📊 Gelir'}
              {categoryName === 'costs' && '💸 Giderler'}
              {categoryName === 'perUnit' && '🎯 Adet Başına Metrikler'}
            </Typography>
            <Grid container spacing={2}>
              {categoryMetrics.map(metric => {
                const { best, worst } = getBestWorst(metric.field);
                
                return (
                  <Grid item xs={12} md={6} lg={4} key={metric.field}>
                    <Card 
                      sx={{ 
                        height: '100%',
                        background: 'linear-gradient(135deg, #ffffffff 0%, #ffffffff 100%)',
                        color: 'black',
                        position: 'relative',
                        overflow: 'visible'
                      }}
                    >
                      <CardContent>
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 2 }}>
                          <Typography variant="subtitle2" sx={{ opacity: 0.9 }}>
                            {metric.icon} {metric.headerName}
                          </Typography>
                        </Box>
                        
                        <Box sx={{ maxHeight: 400, overflowY: 'auto' }}>
                          {validSelections.map(selection => (
                            <Box 
                              key={selection.id} 
                              sx={{ 
                                mb: 1.5,
                                p: 1.5,
                                bgcolor: 'rgba(255,255,255,0.15)',
                                borderRadius: 1,
                                border: selection.displayName === best?.shop ? '2px solid #4ade80' : 
                                       selection.displayName === worst?.shop ? '2px solid #f87171' : 'none',
                              }}
                            >
                              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                <Box sx={{ flex: 1 }}>
                                  <Typography variant="body2" sx={{ fontWeight: 500, fontSize: '0.75rem' }}>
                                    {selection.displayName === best?.shop && '🏆 '}
                                    {selection.displayName === worst?.shop && '📉 '}
                                    {selection.displayName}
                                  </Typography>
                                </Box>
                                <Typography variant="body1" sx={{ fontWeight: 'bold', ml: 1 }}>
                                  {formatValue(selection.metrics[metric.field], metric.format)}
                                </Typography>
                              </Box>
                            </Box>
                          ))}
                        </Box>
                      </CardContent>
                    </Card>
                  </Grid>
                );
              })}
            </Grid>
          </Box>
        ))}
      </Box>
    );
  };

  // Render chart
  const renderChart = () => {
    const validSelections = shopSelections.filter((s) => s.metrics !== null);
    if (validSelections.length === 0) return null;

    const selectedMetricInfo = metricOptions.find((m) => m.field === selectedMetric);
    const chartData = validSelections.map((selection) => ({
      shop: selection.displayName,
      value: selection.metrics[selectedMetric] || 0,
      color: selection.color,
    }));

    switch (chartType) {
      case "bar":
        return (
          <Card>
            <CardContent>
              <Typography variant="h6" gutterBottom>
                {selectedMetricInfo?.icon} {selectedMetricInfo?.headerName} Karşılaştırması
              </Typography>
              <Box sx={{ height: Math.max(400, validSelections.length * 30) }}>
                <ResponsiveContainer>
                  <BarChart data={chartData} layout={validSelections.length > 10 ? "horizontal" : "vertical"}>
                    <CartesianGrid strokeDasharray="3 3" />
                    {validSelections.length > 10 ? (
                      <>
                        <XAxis type="number" />
                        <YAxis dataKey="shop" type="category" width={200} />
                      </>
                    ) : (
                      <>
                        <XAxis dataKey="shop" angle={-45} textAnchor="end" height={100} />
                        <YAxis />
                      </>
                    )}
                    <Tooltip formatter={(value) => formatValue(value, selectedMetricInfo?.format)} />
                    <Legend />
                    <Bar dataKey="value" name={selectedMetricInfo?.headerName}>
                      {chartData.map((entry, index) => (
                        <Cell key={`cell-${index}`} fill={entry.color} />
                      ))}
                    </Bar>
                  </BarChart>
                </ResponsiveContainer>
              </Box>
            </CardContent>
          </Card>
        );

      case "line":
        return (
          <Card>
            <CardContent>
              <Typography variant="h6" gutterBottom>
                {selectedMetricInfo?.icon} {selectedMetricInfo?.headerName} Trend
              </Typography>
              <Box sx={{ height: 400 }}>
                <ResponsiveContainer>
                  <LineChart data={chartData}>
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="shop" angle={-45} textAnchor="end" height={100} />
                    <YAxis />
                    <Tooltip formatter={(value) => formatValue(value, selectedMetricInfo?.format)} />
                    <Legend />
                    <Line type="monotone" dataKey="value" name={selectedMetricInfo?.headerName} stroke="#8884d8" strokeWidth={3} />
                  </LineChart>
                </ResponsiveContainer>
              </Box>
            </CardContent>
          </Card>
        );

      case "pie":
        return (
          <Card>
            <CardContent>
              <Typography variant="h6" gutterBottom>
                {selectedMetricInfo?.icon} {selectedMetricInfo?.headerName} Dağılımı
              </Typography>
              <Box sx={{ height: 400 }}>
                <ResponsiveContainer>
                  <PieChart>
                    <Pie
                      data={chartData}
                      dataKey="value"
                      nameKey="shop"
                      cx="50%"
                      cy="50%"
                      outerRadius={120}
                      label={(entry) => `${entry.shop}: ${formatValue(entry.value, selectedMetricInfo?.format)}`}
                    >
                      {chartData.map((entry, index) => (
                        <Cell key={`cell-${index}`} fill={entry.color} />
                      ))}
                    </Pie>
                    <Tooltip formatter={(value) => formatValue(value, selectedMetricInfo?.format)} />
                  </PieChart>
                </ResponsiveContainer>
              </Box>
            </CardContent>
          </Card>
        );

      case "radar":
        // Haftalık modda radar grafiği için her shop'u grupla
        let radarData;
        if (aggregationMode === 'weekly') {
          // Grup bazlı radar
          const groupedByShop = {};
          validSelections.forEach(selection => {
            const shopKey = selection.rowLabel || selection.shop;
            if (!groupedByShop[shopKey]) {
              groupedByShop[shopKey] = [];
            }
            groupedByShop[shopKey].push(selection);
          });

          radarData = metricOptions.slice(0, 6).map((metric) => {
            const dataPoint = { metric: metric.headerName };
            Object.entries(groupedByShop).forEach(([shopKey, selections]) => {
              const avg = selections.reduce((sum, s) => sum + (Number(s.metrics[metric.field]) || 0), 0) / selections.length;
              dataPoint[shopKey] = avg;
            });
            return dataPoint;
          });
        } else {
          radarData = metricOptions.slice(0, 6).map((metric) => ({
            metric: metric.headerName,
            ...validSelections.reduce((acc, selection) => {
              acc[selection.displayName] = selection.metrics[metric.field] || 0;
              return acc;
            }, {}),
          }));
        }

        return (
          <Card>
            <CardContent>
              <Typography variant="h6" gutterBottom>
                📊 Çoklu Metrik Karşılaştırması
              </Typography>
              <Box sx={{ height: 400 }}>
                <ResponsiveContainer>
                  <RadarChart data={radarData}>
                    <PolarGrid />
                    <PolarAngleAxis dataKey="metric" />
                    <PolarRadiusAxis />
                    <Tooltip />
                    <Legend />
                    {aggregationMode === 'weekly' ? (
                      // Grup bazlı gösterim
                      Object.keys(radarData[0] || {}).filter(key => key !== 'metric').map((shopKey, index) => (
                        <Radar
                          key={shopKey}
                          name={shopKey}
                          dataKey={shopKey}
                          stroke={CHART_COLORS[index % CHART_COLORS.length]}
                          fill={CHART_COLORS[index % CHART_COLORS.length]}
                          fillOpacity={0.3}
                        />
                      ))
                    ) : (
                      validSelections.map((selection) => (
                        <Radar
                          key={selection.id}
                          name={selection.displayName}
                          dataKey={selection.displayName}
                          stroke={selection.color}
                          fill={selection.color}
                          fillOpacity={0.3}
                        />
                      ))
                    )}
                  </RadarChart>
                </ResponsiveContainer>
              </Box>
            </CardContent>
          </Card>
        );

      default:
        return null;
    }
  };

  // Export to Excel
  const exportComparisonToExcel = () => {
    const validSelections = shopSelections.filter((s) => s.metrics !== null);
    if (validSelections.length === 0) {
      alert("Dışa aktarılacak veri yok");
      return;
    }

    const exportData = metricOptions.map((metric) => {
      const row = { Metrik: metric.headerName };
      validSelections.forEach((selection) => {
        const value = selection.metrics[metric.field];
        row[selection.displayName] = formatValue(value, metric.format);
      });
      return row;
    });

    const worksheet = XLSX.utils.json_to_sheet(exportData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Karşılaştırma");
    XLSX.writeFile(workbook, `Magaza_Karsilastirma_${aggregationMode}_${new Date().toISOString().split("T")[0]}.xlsx`);
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns} locale={tr}>
      <Box sx={{ flexGrow: 1, p: 3 }}>
        <Card sx={{ mb: 3 }}>
          <CardContent>
            <Typography variant="h4" gutterBottom sx={{ fontWeight: 'bold', mb: 1 }}>
              🏪 Mağaza Karşılaştırma
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
              Mağazalarınızı farklı dönemlerde karşılaştırın (haftalık detay veya toplam görünüm)
            </Typography>

            {/* Aggregation Mode Toggle */}
            <Box sx={{ mb: 3, p: 2, bgcolor: 'primary.lighter', borderRadius: 2 }}>
              <Typography variant="subtitle2" gutterBottom sx={{ fontWeight: 'bold', mb: 2 }}>
                📊 Görünüm Modu
              </Typography>
              <ToggleButtonGroup
                value={aggregationMode}
                exclusive
                onChange={(e, newMode) => newMode && setAggregationMode(newMode)}
                size="small"
                fullWidth
              >
                <ToggleButton value="sum">
                  📈 Toplam (Özet)
                </ToggleButton>
                <ToggleButton value="weekly">
                  📅 Haftalık Detay (Tüm Satırlar)
                </ToggleButton>
              </ToggleButtonGroup>
              <Typography variant="caption" color="text.secondary" display="block" sx={{ mt: 1 }}>
                {aggregationMode === 'sum' 
                  ? 'Seçili tarih aralığındaki tüm veriler toplanarak gösterilir' 
                  : 'Seçili tarih aralığındaki her haftalık veri ayrı ayrı gösterilir (toplamaz)'
                }
              </Typography>
            </Box>

            {/* Add Row Button */}
            <Box sx={{ mb: 3, display: 'flex', gap: 2, alignItems: 'center' }}>
              <Button
                variant="contained"
                color="primary"
                onClick={addShopRow}
                startIcon={<AddIcon />}
              >
                Karşılaştırma Satırı Ekle
              </Button>

              {selectedShopRows.length > 0 && (
                <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', flex: 1 }}>
                  <Typography variant="caption" color="text.secondary" sx={{ mr: 2, alignSelf: 'center' }}>
                    Tüm Satırlara Hızlı Uygula:
                  </Typography>
                  {presets.map((preset) => (
                    <Chip
                      key={preset.name}
                      label={preset.name}
                      onClick={() => applyPresetToAll(preset.days)}
                      color="primary"
                      variant="outlined"
                      size="small"
                      sx={{ cursor: 'pointer' }}
                    />
                  ))}
                </Box>
              )}
            </Box>

            {/* Shop Rows */}
            {selectedShopRows.length > 0 && (
              <Box sx={{ mb: 3 }}>
                <Typography variant="subtitle2" gutterBottom sx={{ fontWeight: 'bold', mb: 2 }}>
                  📋 Karşılaştırılacak Satırlar
                </Typography>

                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                  {selectedShopRows.map((row, index) => {
                    const color = CHART_COLORS[index % CHART_COLORS.length];
                    
                    return (
                      <Card 
                        key={row.id}
                        sx={{ 
                          borderLeft: `4px solid ${color}`,
                          bgcolor: 'background.paper'
                        }}
                      >
                        <CardContent>
                          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                            <Typography variant="subtitle2" sx={{ fontWeight: 'bold', color }}>
                              Satır #{index + 1}
                            </Typography>
                            <IconButton 
                              size="small" 
                              onClick={() => removeShopRow(row.id)}
                              sx={{ color: 'error.main' }}
                            >
                              ✕
                            </IconButton>
                          </Box>
                          
                          <Grid container spacing={2}>
                            <Grid item xs={12} md={3}>
                              <FormControl fullWidth size="small">
                                <InputLabel>Mağaza</InputLabel>
                                <Select
                                  value={row.shop}
                                  label="Mağaza"
                                  onChange={(e) => updateShopRow(row.id, 'shop', e.target.value)}
                                >
                                  {allShops.map(shop => (
                                    <MenuItem key={shop} value={shop}>{shop}</MenuItem>
                                  ))}
                                </Select>
                              </FormControl>
                            </Grid>
                            
                            <Grid item xs={12} md={3}>
                              <TextField
                                fullWidth
                                size="small"
                                label="Etiket (opsiyonel)"
                                placeholder="ör: Bu Ay, Geçen Ay"
                                value={row.label}
                                onChange={(e) => updateShopRow(row.id, 'label', e.target.value)}
                              />
                            </Grid>

                            <Grid item xs={12} md={3}>
                              <DatePicker
                                label="Başlangıç"
                                value={row.startDate}
                                onChange={(date) => updateShopRow(row.id, 'startDate', date)}
                                renderInput={(params) => <TextField {...params} fullWidth size="small" />}
                                format="dd/MM/yyyy"
                              />
                            </Grid>
                            
                            <Grid item xs={12} md={3}>
                              <DatePicker
                                label="Bitiş"
                                value={row.endDate}
                                onChange={(date) => updateShopRow(row.id, 'endDate', date)}
                                renderInput={(params) => <TextField {...params} fullWidth size="small" />}
                                format="dd/MM/yyyy"
                                minDate={row.startDate}
                              />
                            </Grid>
                          </Grid>
                          
                          {row.startDate && row.endDate && (
                            <Typography variant="caption" color="text.secondary" sx={{ mt: 1, display: 'block' }}>
                              📊 {Math.ceil((row.endDate - row.startDate) / (1000 * 60 * 60 * 24))} gün
                            </Typography>
                          )}
                        </CardContent>
                      </Card>
                    );
                  })}
                </Box>
              </Box>
            )}

            {/* Action Buttons */}
            <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2, mt: 3 }}>
              <Button
                variant="contained"
                color="primary"
                size="large"
                onClick={runComparison}
                disabled={selectedShopRows.length === 0}
                startIcon={<CompareArrowsIcon />}
                sx={{ px: 4 }}
              >
                Karşılaştır ({selectedShopRows.length} Satır)
              </Button>
              {comparisonReady && (
                <Button
                  variant="outlined"
                  size="large"
                  onClick={() => {
                    setComparisonReady(false);
                    setShopSelections([]);
                  }}
                  startIcon={<RefreshIcon />}
                >
                  Sıfırla
                </Button>
              )}
            </Box>
          </CardContent>
        </Card>

        {comparisonReady && shopSelections.some(s => s.metrics !== null) && (
          <>
            {/* Info Banner */}
            {aggregationMode === 'weekly' && (
              <Alert severity="info" sx={{ mb: 3 }}>
                <AlertTitle>Haftalık Detay Modu</AlertTitle>
                Toplam {shopSelections.length} haftalık veri gösteriliyor. Her satır ayrı bir haftalık periyodu temsil ediyor ve değerler toplanmıyor.
              </Alert>
            )}

            {/* Summary Cards */}
            <Grid container spacing={3} sx={{ mb: 3 }}>
              <Grid item xs={12} md={4}>
                <Card sx={{ background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', color: 'white' }}>
                  <CardContent>
                    <Typography variant="subtitle2" sx={{ opacity: 0.9, mb: 1 }}>
                      💰 En Karlı {aggregationMode === 'weekly' ? 'Hafta' : 'Dönem'}
                    </Typography>
                    {(() => {
                      const { best } = getBestWorst('totalProfit');
                      return best ? (
                        <>
                          <Typography variant="body2" sx={{ fontWeight: 'bold', mb: 0.5 }}>
                            {best.shop}
                          </Typography>
                          <Typography variant="h5">
                            {formatCurrency(best.value)}
                          </Typography>
                        </>
                      ) : <Typography>-</Typography>;
                    })()}
                  </CardContent>
                </Card>
              </Grid>

              <Grid item xs={12} md={4}>
                <Card sx={{ background: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)', color: 'white' }}>
                  <CardContent>
                    <Typography variant="subtitle2" sx={{ opacity: 0.9, mb: 1 }}>
                      📊 En Yüksek Satış
                    </Typography>
                    {(() => {
                      const { best } = getBestWorst('totalSalesAmount');
                      return best ? (
                        <>
                          <Typography variant="body2" sx={{ fontWeight: 'bold', mb: 0.5 }}>
                            {best.shop}
                          </Typography>
                          <Typography variant="h5">
                            {formatNumber(best.value)} adet
                          </Typography>
                        </>
                      ) : <Typography>-</Typography>;
                    })()}
                  </CardContent>
                </Card>
              </Grid>

              <Grid item xs={12} md={4}>
                <Card sx={{ background: 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)', color: 'white' }}>
                  <CardContent>
                    <Typography variant="subtitle2" sx={{ opacity: 0.9, mb: 1 }}>
                      🎯 En İyi Adet Başı Kar
                    </Typography>
                    {(() => {
                      const { best } = getBestWorst('profitPerUnit');
                      return best ? (
                        <>
                          <Typography variant="body2" sx={{ fontWeight: 'bold', mb: 0.5 }}>
                            {best.shop}
                          </Typography>
                          <Typography variant="h5">
                            {formatCurrency(best.value)}
                          </Typography>
                        </>
                      ) : <Typography>-</Typography>;
                    })()}
                  </CardContent>
                </Card>
              </Grid>
            </Grid>

            {/* View Mode Toggle */}
            <Box sx={{ mb: 3, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <ToggleButtonGroup
                value={viewMode}
                exclusive
                onChange={(e, newMode) => newMode && setViewMode(newMode)}
                size="small"
              >
                <ToggleButton value="cards">
                  <DashboardIcon sx={{ mr: 1 }} /> Kartlar
                </ToggleButton>
                <ToggleButton value="table">
                  <TableChartIcon sx={{ mr: 1 }} /> Tablo
                </ToggleButton>
              </ToggleButtonGroup>

              <Button
                variant="contained"
                color="success"
                onClick={exportComparisonToExcel}
                startIcon={<DownloadIcon />}
              >
                Excel'e Aktar
              </Button>
            </Box>

            {/* Chart Selection */}
            <Grid container spacing={3} sx={{ mb: 3 }}>
              <Grid item xs={12} md={6}>
                <FormControl fullWidth>
                  <InputLabel>Karşılaştırılacak Metrik</InputLabel>
                  <Select
                    value={selectedMetric}
                    label="Karşılaştırılacak Metrik"
                    onChange={(e) => setSelectedMetric(e.target.value)}
                  >
                    {metricOptions.map((option) => (
                      <MenuItem key={option.field} value={option.field}>
                        {option.icon} {option.headerName}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={12} md={6}>
                <FormControl fullWidth>
                  <InputLabel>Grafik Tipi</InputLabel>
                  <Select
                    value={chartType}
                    label="Grafik Tipi"
                    onChange={(e) => setChartType(e.target.value)}
                  >
                    <MenuItem value="bar">📊 Çubuk Grafik</MenuItem>
                    <MenuItem value="line">📈 Çizgi Grafik</MenuItem>
                    <MenuItem value="pie">🥧 Pasta Grafik</MenuItem>
                    <MenuItem value="radar">🎯 Radar Grafik</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
            </Grid>

            {/* Chart */}
            <Box sx={{ mb: 3 }}>{renderChart()}</Box>

            <Divider sx={{ my: 3 }} />

            {/* Detailed View */}
            {viewMode === 'cards' ? renderMetricCards() : (
              <Card>
                <CardContent>
                  <Typography variant="h6" gutterBottom>
                    📋 Detaylı Karşılaştırma Tablosu ({shopSelections.filter(s => s.metrics !== null).length} {aggregationMode === 'weekly' ? 'Hafta' : 'Dönem'})
                  </Typography>
                  <TableContainer sx={{ maxHeight: 600 }}>
                    <Table stickyHeader>
                      <TableHead>
                        <TableRow>
                          <TableCell>
                            <strong>Metrik</strong>
                          </TableCell>
                          {shopSelections
                            .filter((s) => s.metrics !== null)
                            .map((selection) => (
                              <TableCell key={selection.id} align="right">
                                <strong style={{ color: selection.color, fontSize: '0.75rem' }}>
                                  {selection.displayName}
                                </strong>
                              </TableCell>
                            ))}
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {getSortedMetrics().map((metric) => {
                          const validSelections = shopSelections.filter((s) => s.metrics !== null);
                          const { best, worst } = getBestWorst(metric.field);

                          return (
                            <TableRow 
                              key={metric.field}
                              sx={{ '&:hover': { bgcolor: 'action.hover' } }}
                            >
                              <TableCell>
                                {metric.icon} {metric.headerName}
                              </TableCell>
                              {validSelections.map((selection) => (
                                <TableCell 
                                  key={selection.id} 
                                  align="right"
                                  sx={{
                                    fontWeight: selection.displayName === best?.shop ? 'bold' : 'normal',
                                    bgcolor: selection.displayName === best?.shop ? 'success.light' : 
                                            selection.displayName === worst?.shop ? 'error.light' : 'transparent',
                                    color: selection.displayName === best?.shop || selection.displayName === worst?.shop ? 'white' : 'text.primary',
                                    fontSize: '0.875rem'
                                  }}
                                >
                                  {selection.displayName === best?.shop && '🏆 '}
                                  {selection.displayName === worst?.shop && '📉 '}
                                  {formatValue(selection.metrics[metric.field], metric.format)}
                                </TableCell>
                              ))}
                            </TableRow>
                          );
                        })}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </CardContent>
              </Card>
            )}
          </>
        )}
      </Box>
    </LocalizationProvider>
  );
};

  const handleFetchData = async () => {
    setLoading(true);
    setError("");
    setUserData([]);
    setUserEarnings({}); // Yeni veri getirirken önceki hesaplamaları temizle

    try {
      const formattedStartDate = dayjs(startDate).format("YYYY-MM-DD");
      const formattedEndDate = dayjs(endDate).format("YYYY-MM-DD");

      console.log("Start Date:", formattedStartDate);
      console.log("End Date:", formattedEndDate);

      const response = await axios.post(
        `${path}/api/GetUserEffortViaParamaters`,
        {
          UserID: user?.ID,
          isAdmin: user?.Admin,
          startDate: formattedStartDate,
          endDate: formattedEndDate,
        }
      );

      try {
        const response = await axios.post(
          path + "/api/AllEffortsFees",
          {
            UserID: user?.ID,
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
        const parsedData = response.data;
        console.log(response.data);
        if (parsedData && parsedData.length > 0) {
          const updatedEfforts = userData.map((user) => {
            const existingEffort = parsedData.find(
              (effort) => effort.userId === user.UserID
            );

            return {
              userId: user.UserID,
              userName: user.UserName,
              effortType1: existingEffort?.effortType1 || "",
              effortType1Fee: existingEffort?.effortType1Fee || "",
              effortType2: existingEffort?.effortType2 || "",
              effortType2Fee: existingEffort?.effortType2Fee || "",
            };
          });
          setUserEffortsFees(updatedEfforts);
        }
      } catch (error) {
        console.error("Error fetching shop data:", error);
      }

      console.log("API Response:", response.data);
      setUserData(response.data);
      console.log(
        "Fetched userData:",
        response.data.length + " records " + userEffortsFees.length
      );
      if (response.data.length > 0 && userEffortsFees.length > 0) {
        const calculatedEarnings = calculateUserEarnings();
        setUserEarnings(calculatedEarnings);
        console.log("Calculated userEarnings:", calculatedEarnings);
      }
    } catch (error) {
      setError("Veriler alınırken hata oluştu.");
      console.error("Error fetching shop data:", error);
    } finally {
      setLoading(false);
    }
  };

  const calculateUserEarnings = () => {
    const userEarnings = {};

    userData.forEach((record) => {
      if (!userEarnings[record.UserName]) {
        userEarnings[record.UserName] = {
          argeHours: 0,
          argeEarnings: 0,
          otherHours: 0,
          otherEarnings: 0,
          totalHours: 0,
          totalEarnings: 0,
          shops: {},
        };
      }

      const [hours, minutes] = record.TimeSummary.split(":").map(Number);
      const durationHours = hours + minutes / 60;

      const userFee = userEffortsFees.find(
        (fee) => fee.userId === record.UserID
      );
      if (!userFee) return;

      if (record.Shop === "Arge") {
        const rate = parseFloat(userFee.effortType2Fee) || 0;
        userEarnings[record.UserName].argeHours += durationHours;
        userEarnings[record.UserName].argeEarnings += durationHours * rate;
      } else {
        const rate = parseFloat(userFee.effortType1Fee) || 0;
        userEarnings[record.UserName].otherHours += durationHours;
        userEarnings[record.UserName].otherEarnings += durationHours * rate;
        if (!userEarnings[record.UserName].shops[record.Shop]) {
          userEarnings[record.UserName].shops[record.Shop] = {
            hours: 0,
            earnings: 0,
          };
        }
        userEarnings[record.UserName].shops[record.Shop].hours += durationHours;
        userEarnings[record.UserName].shops[record.Shop].earnings +=
          durationHours * rate;
      }

      userEarnings[record.UserName].totalHours += durationHours;
      userEarnings[record.UserName].totalEarnings =
        userEarnings[record.UserName].argeEarnings +
        userEarnings[record.UserName].otherEarnings;
    });

    console.log("Calculated userEarnings:", userEarnings);
    return userEarnings;
  };
  const [userEarnings, setUserEarnings] = useState([]);

  useEffect(() => {
    console.log("useEffect triggered - userData length:", userData.length);
    console.log(
      "useEffect triggered - userEffortsFees length:",
      userEffortsFees.length
    );

    // Her ikisi de dolu olduğunda hesapla
    if (userData.length > 0 && userEffortsFees.length > 0) {
      const calculatedEarnings = calculateUserEarnings();
      setUserEarnings(calculatedEarnings);
    } else {
      // Veriler boşsa state'i temizle
      setUserEarnings({});
    }
  }, [userData, userEffortsFees]);

  const filteredEarnings = React.useMemo(() => {
    console.log("filteredEarnings memo - userEarnings:", userEarnings);
    console.log(
      "filteredEarnings memo - startDate:",
      startDate,
      "endDate:",
      endDate
    );

    // Eğer tarih filtresi yoksa, mevcut userEarnings'i döndür
    if (!startDate && !endDate) {
      return userEarnings;
    }

    const filtered = {};

    userData.forEach((record) => {
      const recordDate = new Date(record.EffortDate);
      recordDate.setHours(0, 0, 0, 0);

      let dateMatch = true;

      if (startDate) {
        const startDateObj = new Date(startDate);
        startDateObj.setHours(0, 0, 0, 0);
        dateMatch = dateMatch && recordDate >= startDateObj;
      }

      if (endDate) {
        const endDateObj = new Date(endDate);
        endDateObj.setHours(0, 0, 0, 0);
        dateMatch = dateMatch && recordDate <= endDateObj;
      }

      if (dateMatch) {
        const userName = record.UserName;
        if (!filtered[userName]) {
          filtered[userName] = {
            argeHours: 0,
            argeEarnings: 0,
            otherHours: 0,
            otherEarnings: 0,
            totalHours: 0,
            totalEarnings: 0,
          };
        }

        const hours =
          parseFloat(record.TimeSummary.split(":")[0]) +
          parseFloat(record.TimeSummary.split(":")[1]) / 60;

        const userFee = userEffortsFees.find(
          (fee) => fee.userId === record.UserID
        );
        if (!userFee) return;

        if (record.Shop === "Arge") {
          const argeRate = parseFloat(userFee.effortType2Fee) || 0;
          filtered[userName].argeHours += hours;
          filtered[userName].argeEarnings += hours * argeRate;
        } else {
          const shopRate = parseFloat(userFee.effortType1Fee) || 0;
          filtered[userName].otherHours += hours;
          filtered[userName].otherEarnings += hours * shopRate;
        }

        filtered[userName].totalHours += hours;
        filtered[userName].totalEarnings =
          filtered[userName].argeEarnings + filtered[userName].otherEarnings;
      }
    });

    console.log("Filtered Earnings:", filtered);
    return filtered;
  }, [userData, userEffortsFees, startDate, endDate, userEarnings]);

  const UserEarningsScreen = () => {
    // State tanımlamaları
    const [localUserData, setLocalUserData] = useState([]);
    const [localUserEffortsFees, setLocalUserEffortsFees] = useState([]);
    const [localUserEarnings, setLocalUserEarnings] = useState({});
    const [localStartDate, setLocalStartDate] = useState(null);
    const [localEndDate, setLocalEndDate] = useState(null);
    const [localSelectedUser, setLocalSelectedUser] = useState("all");
    const [localLoading, setLocalLoading] = useState(false);
    const [localError, setLocalError] = useState("");

    // Veri getirme fonksiyonu
    const handleLocalFetchData = async () => {
      setLocalLoading(true);
      setLocalError("");
      setLocalUserData([]);
      setLocalUserEarnings({}); // Yeni veri getirirken önceki hesaplamaları temizle

      try {
        const formattedLocalStartDate =
          dayjs(localStartDate).format("YYYY-MM-DD");
        const formattedLocalEndDate = dayjs(localEndDate).format("YYYY-MM-DD");

        console.log("Local Start Date:", formattedLocalStartDate);
        console.log("Local End Date:", formattedLocalEndDate);

        const userResponse = await axios.post(
          `${path}/api/GetUserEffortViaParamaters`,
          {
            UserID: user?.ID,
            isAdmin: user?.Admin,
            startDate: formattedLocalStartDate,
            endDate: formattedLocalEndDate,
          }
        );

        try {
          const feesResponse = await axios.post(
            path + "/api/AllEffortsFees",
            {
              UserID: user?.ID,
            },
            {
              headers: {
                "Content-Type": "application/json",
              },
            }
          );
          const parsedFeesData = feesResponse.data;
          console.log("Local fees response:", feesResponse.data);

          if (parsedFeesData && parsedFeesData.length > 0) {
            const updatedLocalEfforts = userResponse.data.map((userData) => {
              const existingLocalEffort = parsedFeesData.find(
                (effort) => effort.userId === userData.UserID
              );

              return {
                userId: userData.UserID,
                userName: userData.UserName,
                effortType1: existingLocalEffort?.effortType1 || "",
                effortType1Fee: existingLocalEffort?.effortType1Fee || "",
                effortType2: existingLocalEffort?.effortType2 || "",
                effortType2Fee: existingLocalEffort?.effortType2Fee || "",
              };
            });
            setLocalUserEffortsFees(updatedLocalEfforts);
          }
        } catch (error) {
          console.error("Error fetching local fees data:", error);
        }

        console.log("Local API Response:", userResponse.data);
        setLocalUserData(userResponse.data);
        console.log(
          "Fetched local userData:",
          userResponse.data.length + " records"
        );
      } catch (error) {
        setLocalError("Veriler alınırken hata oluştu.");
        console.error("Error fetching local data:", error);
      } finally {
        setLocalLoading(false);
      }
    };

    // Kullanıcı kazancı hesaplama fonksiyonu
    const calculateLocalUserEarnings = () => {
      const localEarningsData = {};

      localUserData.forEach((record) => {
        if (!localEarningsData[record.UserName]) {
          localEarningsData[record.UserName] = {
            argeHours: 0,
            argeEarnings: 0,
            otherHours: 0,
            otherEarnings: 0,
            totalHours: 0,
            totalEarnings: 0,
            shops: {},
          };
        }

        const [hours, minutes] = record.TimeSummary.split(":").map(Number);
        const durationHours = hours + minutes / 60;

        const localUserFee = localUserEffortsFees.find(
          (fee) => fee.userId === record.UserID
        );
        if (!localUserFee) return;

        if (record.Shop === "Arge") {
          const rate = parseFloat(localUserFee.effortType2Fee) || 0;
          localEarningsData[record.UserName].argeHours += durationHours;
          localEarningsData[record.UserName].argeEarnings +=
            durationHours * rate;
        } else {
          const rate = parseFloat(localUserFee.effortType1Fee) || 0;
          localEarningsData[record.UserName].otherHours += durationHours;
          localEarningsData[record.UserName].otherEarnings +=
            durationHours * rate;

          if (!localEarningsData[record.UserName].shops[record.Shop]) {
            localEarningsData[record.UserName].shops[record.Shop] = {
              hours: 0,
              earnings: 0,
            };
          }
          localEarningsData[record.UserName].shops[record.Shop].hours +=
            durationHours;
          localEarningsData[record.UserName].shops[record.Shop].earnings +=
            durationHours * rate;
        }

        localEarningsData[record.UserName].totalHours += durationHours;
        localEarningsData[record.UserName].totalEarnings =
          localEarningsData[record.UserName].argeEarnings +
          localEarningsData[record.UserName].otherEarnings;
      });

      console.log("Calculated local userEarnings:", localEarningsData);
      return localEarningsData;
    };

    
    // useEffect - Veri değişimlerini izle
    useEffect(() => {
      console.log(
        "Local useEffect triggered - userData length:",
        localUserData.length
      );
      console.log(
        "Local useEffect triggered - userEffortsFees length:",
        localUserEffortsFees.length
      );

      // Her ikisi de dolu olduğunda hesapla
      if (localUserData.length > 0 && localUserEffortsFees.length > 0) {
        const calculatedLocalEarnings = calculateLocalUserEarnings();
        setLocalUserEarnings(calculatedLocalEarnings);
      } else {
        // Veriler boşsa state'i temizle
        setLocalUserEarnings({});
      }
    }, [localUserData, localUserEffortsFees]);

    // Filtrelenmiş kazançlar
    const filteredLocalEarnings = React.useMemo(() => {
      console.log(
        "Local filteredEarnings memo - userEarnings:",
        localUserEarnings
      );
      console.log(
        "Local filteredEarnings memo - startDate:",
        localStartDate,
        "endDate:",
        localEndDate
      );

      // Eğer tarih filtresi yoksa, mevcut userEarnings'i döndür
      if (!localStartDate && !localEndDate) {
        return localUserEarnings;
      }

      const filteredLocal = {};

      localUserData.forEach((record) => {
        const recordDate = new Date(record.EffortDate);
        recordDate.setHours(0, 0, 0, 0);

        let dateMatch = true;

        if (localStartDate) {
          const startDateObj = new Date(localStartDate);
          startDateObj.setHours(0, 0, 0, 0);
          dateMatch = dateMatch && recordDate >= startDateObj;
        }

        if (localEndDate) {
          const endDateObj = new Date(localEndDate);
          endDateObj.setHours(0, 0, 0, 0);
          dateMatch = dateMatch && recordDate <= endDateObj;
        }

        if (dateMatch) {
          const userName = record.UserName;
          if (!filteredLocal[userName]) {
            filteredLocal[userName] = {
              argeHours: 0,
              argeEarnings: 0,
              otherHours: 0,
              otherEarnings: 0,
              totalHours: 0,
              totalEarnings: 0,
            };
          }

          const hours =
            parseFloat(record.TimeSummary.split(":")[0]) +
            parseFloat(record.TimeSummary.split(":")[1]) / 60;

          const localUserFee = localUserEffortsFees.find(
            (fee) => fee.userId === record.UserID
          );
          if (!localUserFee) return;

          if (record.Shop === "Arge") {
            const argeRate = parseFloat(localUserFee.effortType2Fee) || 0;
            filteredLocal[userName].argeHours += hours;
            filteredLocal[userName].argeEarnings += hours * argeRate;
          } else {
            const shopRate = parseFloat(localUserFee.effortType1Fee) || 0;
            filteredLocal[userName].otherHours += hours;
            filteredLocal[userName].otherEarnings += hours * shopRate;
          }

          filteredLocal[userName].totalHours += hours;
          filteredLocal[userName].totalEarnings =
            filteredLocal[userName].argeEarnings +
            filteredLocal[userName].otherEarnings;
        }
      });

      console.log("Local Filtered Earnings:", filteredLocal);
      return filteredLocal;
    }, [
      localUserData,
      localUserEffortsFees,
      localStartDate,
      localEndDate,
      localUserEarnings,
    ]);

    const exportLocalToExcel = () => {
  if (Object.keys(filteredLocalEarnings).length === 0) {
    alert("Excel'e aktarılacak veri bulunamadı. Önce verileri getirin.");
    return;
  }

  // Filtrelenmiş verileri al
  const dataToExport = Object.entries(filteredLocalEarnings)
    .filter(
      ([userName]) =>
        localSelectedUser === "all" || userName === localSelectedUser
    )
    .map(([userName, earnings]) => ({
      "Kullanıcı": userName,
      "Arge Saatleri": earnings.argeHours.toFixed(2),
      "Arge Kazancı": `$${earnings.argeEarnings.toFixed(2)}`,
      "Diğer Saatler": earnings.otherHours.toFixed(2),
      "Diğer Kazanç": `$${earnings.otherEarnings.toFixed(2)}`,
      "Toplam Saat": earnings.totalHours.toFixed(2),
      "Toplam Kazanç": `$${earnings.totalEarnings.toFixed(2)}`
    }));

  const ws = XLSX.utils.json_to_sheet(dataToExport);

  // Column genişliklerini ayarla
  const colWidths = [
    { wch: 20 }, // Kullanıcı
    { wch: 15 }, // Arge Saatleri
    { wch: 15 }, // Arge Kazancı
    { wch: 15 }, // Diğer Saatler
    { wch: 15 }, // Diğer Kazanç
    { wch: 15 }, // Toplam Saat
    { wch: 15 }  // Toplam Kazanç
  ];
  ws['!cols'] = colWidths;

  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "Kullanıcı Kazançları");

  let fileName = "kullanici_kazanclari";
  if (localStartDate && localEndDate) {
    const startStr = dayjs(localStartDate).format("YYYY-MM-DD");
    const endStr = dayjs(localEndDate).format("YYYY-MM-DD");
    fileName += `_${startStr}_${endStr}`;
  }
  fileName += ".xlsx";

  // Dosyayı indir
  XLSX.writeFile(wb, fileName);
};

    // Ana component render
    return (
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <div style={{ padding: "24px" }}>
          <Grid container spacing={3}>
            {/* Date Range Selection */}
            <Grid item xs={12} md={8}>
              <Card>
                <CardContent>
                  <Typography variant="h6" gutterBottom>
                    Tarih Aralığı
                  </Typography>

                  {/* Tarih Seçimi ve Butonu Yan Yana Getiren Satır */}
                  <Grid container spacing={2} alignItems="center">
                    <Grid item xs={12} md={4}>
                      <DatePicker
                        label="Başlangıç Tarihi"
                        value={localStartDate}
                        onChange={setLocalStartDate}
                        renderInput={(params) => (
                          <TextField {...params} fullWidth />
                        )}
                      />
                    </Grid>
                    <Grid item xs={12} md={4}>
                      <DatePicker
                        label="Bitiş Tarihi"
                        value={localEndDate}
                        onChange={setLocalEndDate}
                        renderInput={(params) => (
                          <TextField {...params} fullWidth />
                        )}
                      />
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      md={4}
                      display="flex"
                      justifyContent="center"
                    >
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={handleLocalFetchData}
                        disabled={localLoading}
                        sx={{ minWidth: 180, height: 56 }}
                      >
                        {localLoading ? "Yükleniyor..." : "Verileri Getir"}
                      </Button>
                    </Grid>
                  </Grid>

                  {/* Bilgilendirme Mesajını Butonun Altına Uzun Yazmak İçin */}
                  <Grid container justifyContent="center" sx={{ mt: 2 }}>
                    <Grid item xs={12}>
                      <Typography
                        variant="h6"
                        color={localUserData.length === 0 ? "error" : "success"}
                        align="center"
                      >
                        {localUserData.length === 0
                          ? "Lütfen Başlangıç ve Bitiş Tarihlerini Seçiniz ve Verileri Getir Butonuna Basınız"
                          : "Farklı Tarihte Veri Seçimi Yapabilirsiniz"}
                      </Typography>
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
            </Grid>

            {/* User Filter */}
            <Grid item xs={12} md={4}>
              <Card>
                <CardContent>
                  <Typography variant="h6" gutterBottom>
                    Kullanıcı Filtresi
                  </Typography>
                  <FormControl fullWidth>
                    <InputLabel>Kullanıcı Seç</InputLabel>
                    <Select
                      value={localSelectedUser}
                      onChange={(e) => setLocalSelectedUser(e.target.value)}
                      label="Kullanıcı Seç"
                    >
                      <MenuItem value="all">Tüm Kullanıcılar</MenuItem>
                      {Object.keys(filteredLocalEarnings).map((userName) => (
                        <MenuItem key={userName} value={userName}>
                          {userName}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </CardContent>
              </Card>
            </Grid>
            {/* Earnings Table */}
            <Grid item xs={12}>
              <Card>
                <CardContent>
                  <Typography variant="h6" gutterBottom>
                    Kazanç Özeti
                  </Typography>
                  <Button
                    variant="contained"
                    color="primary"
                    style={{ marginBottom: "16px" }}
                    onClick={exportLocalToExcel}
                  >
                    Excel'e Aktar
                  </Button>
                  <TableContainer component={Paper}>
                    <Table>
                      <TableHead>
                        <TableRow>
                          <TableCell>Kullanıcı</TableCell>
                          <TableCell>Arge Saatleri</TableCell>
                          <TableCell>Arge Kazancı</TableCell>
                          <TableCell>Diğer Saatler</TableCell>
                          <TableCell>Diğer Kazanç</TableCell>
                          <TableCell>Toplam Saat</TableCell>
                          <TableCell>Toplam Kazanç</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {Object.entries(filteredLocalEarnings)
                          .filter(
                            ([userName]) =>
                              localSelectedUser === "all" ||
                              userName === localSelectedUser
                          )
                          .map(([userName, earnings]) => (
                            <TableRow key={userName}>
                              <TableCell>{userName}</TableCell>
                              <TableCell>
                                {earnings.argeHours.toFixed(2)}
                              </TableCell>
                              <TableCell>
                                ${earnings.argeEarnings.toFixed(2)}
                              </TableCell>
                              <TableCell>
                                {earnings.otherHours.toFixed(2)}
                              </TableCell>
                              <TableCell>
                                ${earnings.otherEarnings.toFixed(2)}
                              </TableCell>
                              <TableCell>
                                {earnings.totalHours.toFixed(2)}
                              </TableCell>
                              <TableCell style={{ fontWeight: "bold" }}>
                                ${earnings.totalEarnings.toFixed(2)}
                              </TableCell>
                            </TableRow>
                          ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        </div>
      </LocalizationProvider>
    );
  };



  const CustomScreenShotControl = () => {
    const [users, setUsers] = useState([]);
    useEffect(() => {
      const fetchUsers = async () => {
        try {
          const response = await axios.post(
            path + "/api/GetActivePersonnels",
            {
              UserID: user?.ID,
            },
            {
              headers: {
                "Content-Type": "application/json",
              },
            }
          );

          const parsedData = response.data;
          console.log(parsedData);
          setUsers(parsedData);
        } catch (error) {
          console.error("Error fetching shop data:", error);
        }
      };
      fetchUsers();
    }, []);

    const [selectedUser, setSelectedUser] = useState(null);
    const [startDate, setStartDate] = useState(dayjs());
    const [endDate, setEndDate] = useState(dayjs());
    const [screenshots, setScreenshots] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const [page, setPage] = useState(0);
    const [itemsPerPage] = useState(60);

    const handleFetchScreenshots = async () => {
      try {
        setLoading(true);
        setError("");
        setPage(0);

        const startDateTime = startDate.format("YYYY-MM-DD HH:mm:ss");
        const endDateTime = endDate.format("YYYY-MM-DD HH:mm:ss");

        const response = await axios.post(`${path}/api/GetScreenShots`, {
          startDate: startDateTime,
          endDate: endDateTime,
          userName: selectedUser,
        });

        setScreenshots(response.data);
      } catch (err) {
        setError("Ekran görüntüleri yüklenirken bir hata oluştu.");
        console.error("Error fetching screenshots:", err);
      } finally {
        setLoading(false);
      }
    };

    const pageCount = Math.ceil(screenshots.length / itemsPerPage);
    const currentPageItems = screenshots.slice(
      page * itemsPerPage,
      (page + 1) * itemsPerPage
    );

    return (
      <Box sx={{ p: 3 }}>
        <Paper elevation={3} sx={{ p: 3, mb: 4 }}>
          <Box
            sx={{
              display: "flex",
              gap: 2,
              flexWrap: "wrap",
              alignItems: "center",
              mb: 3,
            }}
          >
            <FormControl sx={{ minWidth: 200 }}>
              <InputLabel>Kullanıcı</InputLabel>
              <Select
                value={selectedUser}
                onChange={(e) => setSelectedUser(e.target.value)}
                label="Kullanıcı"
              >
                {users.map((user) => (
                  <MenuItem key={user.UserID} value={user.Username}>
                    {user.Username}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DateTimePicker
                label="Başlangıç Tarihi"
                value={startDate}
                onChange={setStartDate}
                sx={{ minWidth: 250 }}
                ampm={false}
              />
              <DateTimePicker
                label="Bitiş Tarihi"
                value={endDate}
                onChange={setEndDate}
                sx={{ minWidth: 250 }}
                ampm={false}
              />
            </LocalizationProvider>

            <Button
              variant="contained"
              onClick={handleFetchScreenshots}
              sx={{ height: 56 }}
            >
              Ekran Görüntülerini Getir
            </Button>
          </Box>

          {screenshots.length > 0 && (
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                mt: 2,
              }}
            >
              <Typography>Toplam: {screenshots.length} görüntü</Typography>
              <Pagination
                count={pageCount}
                page={page + 1}
                onChange={(e, newPage) => setPage(newPage - 1)}
                color="primary"
              />
            </Box>
          )}
        </Paper>

        <Box sx={{ mt: 4 }}>
          {loading ? (
            <Box
              display="flex"
              justifyContent="center"
              alignItems="center"
              height={400}
            >
              <Typography sx={{ ml: 2 }}>Yükleniyor...</Typography>
            </Box>
          ) : error ? (
            <Box
              display="flex"
              justifyContent="center"
              alignItems="center"
              color="error.main"
            >
              {error}
            </Box>
          ) : screenshots.length === 0 ? (
            <Box
              display="flex"
              justifyContent="center"
              alignItems="center"
              color="text.secondary"
            >
              Bu zaman aralığında ekran görüntüsü bulunmamaktadır.
            </Box>
          ) : (
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                maxHeight: "1000px",
                overflow: "auto",
                p: 2,
              }}
            >
              {currentPageItems.map((screenshot, index) => (
                <Box
                  key={index}
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    width: "120%",
                    maxWidth: 1000,
                    border: "1px solid",
                    borderColor: "divider",
                    borderRadius: 2,
                    p: 2,
                    boxShadow: 1,
                    mb: 2,
                  }}
                >
                  <Box
                    sx={{
                      width: "100%",
                      maxHeight: 900,
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      overflow: "hidden",
                    }}
                  >
                    <Box
                      component="img"
                      src={screenshot.ScreenshotPath}
                      alt={`Ekran Görüntüsü ${index + 1}`}
                      sx={{
                        maxWidth: "100%",
                        height: "auto",
                        objectFit: "contain",
                      }}
                      onError={(e) => {
                        e.target.src = "/api/placeholder/400/300";
                      }}
                    />
                  </Box>
                  <Typography variant="caption" color="text.secondary" mt={1}>
                    {screenshot.UploadDateString}
                  </Typography>
                </Box>
              ))}
            </Box>
          )}
        </Box>
      </Box>
    );
  };

  const menuItems = [
    { text: "Kullanıcı Raporları", icon: <PeopleIcon /> },
    { text: "Shop Raporları", icon: <StoreIcon /> },
    { text: "Karşılaştırmalı Raporlar", icon: <BarChartIcon /> },
    { text: "Kullanıcı Ücretleri", icon: <AttachMoneyIcon /> },
    { text: "Kullanıcı Takip", icon: <VisibilityIcon /> },
  ];

  return (
    <>
      <Snackbar
        open={alertOpen}
        autoHideDuration={6000}
        onClose={() => setAlertOpen(false)}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={() => setAlertOpen(false)} severity={alertSeverity}>
          {alertMessage}
        </Alert>
      </Snackbar>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          minHeight: "100vh",
          bgcolor: "rgb(180, 190, 190)",
          p: 2,
          overflow: "auto",
        }}
      >
        <Box sx={{ display: "flex" }}>
          <CssBaseline />
          <AppBar
            position="fixed"
            open={open}
            style={{ backgroundColor: "#405D72" }}
          >
            <Toolbar style={{ backgroundColor: "#405D72" }}>
              <IconButton
                color="inherit"
                aria-label="open drawer"
                onClick={handleDrawerOpen}
                edge="start"
                sx={[
                  {
                    mr: 2,
                  },
                  open && { display: "none" },
                ]}
              >
                <MenuIcon />
              </IconButton>
              <Typography variant="h6" noWrap component="div">
                Kullanıcı Raporları
              </Typography>

              <IconButton
                onClick={() => navigate("/")}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                  padding: "5px 15px",
                  borderRadius: "25px",
                  backgroundColor: "#fff",
                  ml: "auto",
                  "&:hover": {
                    backgroundColor: "#ccc",
                  },
                }}
              >
                <Avatar
                  src="/Logos/HORSE HEAD.svg"
                  alt="Ana Menü"
                  sx={{ width: 50, height: 50 }}
                />
                <Typography
                  variant="h6"
                  sx={{
                    fontWeight: "bold",
                    color: "#000",
                  }}
                >
                  Ana Menü
                </Typography>
              </IconButton>
            </Toolbar>
          </AppBar>
          <Drawer
            sx={{
              width: drawerWidth,
              flexShrink: 0,
              "& .MuiDrawer-paper": {
                width: drawerWidth,
                boxSizing: "border-box",
                backgroundColor: "#DDE7F2",
              },
            }}
            variant="persistent"
            anchor="left"
            open={open}
          >
            <Toolbar>
              <IconButton onClick={handleDrawerClose}>
                <ChevronLeftIcon />
              </IconButton>
            </Toolbar>
            <Divider />
            <List>
              {menuItems.map(({ text, icon }) => (
                <ListItem key={text} disablePadding>
                  <ListItemButton onClick={() => handleMenuClick(text)}>
                    <ListItemIcon>{icon}</ListItemIcon>
                    <ListItemText primary={text} />
                  </ListItemButton>
                </ListItem>
              ))}
            </List>
            <Divider />
          </Drawer>
          ;
          <Box component="main" sx={{ flexGrow: 1, p: 3, maxHeight: "100vh" }}>
            <Toolbar />
            {/* Menüye göre dinamik içerik */}
            {selectedMenu === "Kullanıcı Raporları" && (
              <Typography>
                <UserDetailReports />
              </Typography>
            )}
            {selectedMenu === "Shop Raporları" && (
              <Typography>
                <ShopData />
              </Typography>
            )}
            {/* Diğer menü öğelerine içerik eklenebilir */}
            {selectedMenu === "Karşılaştırmalı Raporlar" && (
              <Typography>
                {user.Admin === 1 || user.Username === "osman kale" ? (
                  <CompareShops />
                ) : (
                  "Yetkiniz yok!"
                )}
              </Typography>
            )}
            {selectedMenu === "Kullanıcı Ücretleri" && (
              <Typography>
                {user.Admin === 1 || user.Username === "osman kale" ? (
                  <UserEarningsScreen />
                ) : (
                  "Yetkiniz yok!"
                )}
              </Typography>
            )}
           {selectedMenu === "Kullanıcı Takip" && user?.Admin === 1 && (
              <Typography>
                <CustomScreenShotControl />
              </Typography>
            )}
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default UserReports;
